import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../../../context/LoadingContext";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
  TextField,
  IconButton,
  Modal,
  Paper,
  Checkbox,
  ListItemText,
  OutlinedInput,
  FormControlLabel,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// Add these imports at the top of the file if not already present
import { Autocomplete } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
  uploadVideoToS3,
} from "../../../../../services/BackendServices";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import config from "../../../../../aws-exports";
import GenerateFinanceRFQModal from "./GenerateFinanceRFQModal";
import RFQInformationTab from "./formtabs/RFQInformationTab";
import CommodityDetailsTab from "./formtabs/CommodityDetailsTab";
import DeliveryTermsTab from "./formtabs/DeliveryTermsTab";
import QuantityPackagingTab from "./formtabs/QuantityPackagingTab";
import PricingPaymentTab from "./formtabs/PricingPaymentTab";
import OthersTab from "./formtabs/OthersTab";

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const RFQForm = ({
  formMode,
  setFormMode,
  selectedRFQ,
  setIsFormVisible,
  productList,
  allProductMaster,
  activeUser,
  buyerInfo,
  totalItems,
  setModal,
  searchRFQs,
  searchValues,
  navigate,
  btnCancel = true,
  btnHistory = false,
  btnAddFinanceRfq = false,
  onHistoryClick,
}) => {
  const { setLoading } = useLoading();
  const [tabValue, setTabValue] = useState(0);

  // RFQ Information Tab
  const [title, setTitle] = useState("");
  const [createDate, setCreateDate] = useState("");
  const [submitedDate, setSubmitedDate] = useState("");
  const [validUntil, setValidUntil] = useState("");
  const [buyerEmailID, setBuyerEmailID] = useState("");

  // Commodity Details Tab
  const [category, setCategory] = useState("");
  const [product, setProduct] = useState("");
  const [hsCode, setHsCode] = useState("");
  const [grade, setGrade] = useState("");
  const [variety, setVariety] = useState("");
  const [productSpecifications, setProductSpecifications] = useState("");
  const [origin, setOrigin] = useState("");
  const [additionalProductNotes, setAdditionalProductNotes] = useState("");

  // Quantity & Packaging Tab
  const [requestedQuantity, setRequestedQuantity] = useState("");
  const [productPackaging, setProductPackaging] = useState("");
  const [packageSize, setPackageSize] = useState("");
  const [additionalPackagingNotes, setAdditionalPackagingNotes] = useState("");

  // Delivery Terms Tab
  const [destination, setDestination] = useState("");
  const [deliveryPort, setDeliveryPort] = useState("");
  const [incoterm, setIncoterm] = useState("");
  const [deliveryPeriodFrom, setDeliveryPeriodFrom] = useState("");
  const [deliveryPeriodTill, setDeliveryPeriodTill] = useState("");
  const [shippingMethodPreference, setShippingMethodPreference] = useState("");
  const [partialDeliveryAllowed, setPartialDeliveryAllowed] = useState(0);
  const [additionalLogisticsNotes, setAdditionalLogisticsNotes] = useState("");
  const [unloadingResponsibility, setUnloadingResponsibility] =
    useState("Buyer");
  const [transshipmentAllowed, setTransshipmentAllowed] = useState(0);

  // Pricing/Payment/Guarantee Tab
  const [priceOffered, setPriceOffered] = useState("");
  const [currency, setCurrency] = useState("");
  const [preferredPaymentMethod, setPreferredPaymentMethod] = useState("");
  const [paymentTimeline, setPaymentTimeline] = useState("");
  const [specialInstructionsSuppliers, setSpecialInstructionsSuppliers] =
    useState("");
  const [qualityInspectionRequired, setQualityInspectionRequired] = useState(0);
  const [requiredSupplierCertifications, setRequiredSupplierCertifications] =
    useState(0);
  const [comparisonCriteriaPriority, setComparisonCriteriaPriority] = useState(
    []
  );

  // Others Tab
  const [internalComments, setInternalComments] = useState("");
  // const [termsAndConditions, setTermsAndConditions] = useState([]);
  // const [otherFiles, setOtherFiles] = useState([]);
  // const [paymentConditionFiles, setPaymentConditionFiles] = useState([]);

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  // const [openTermsModal, setOpenTermsModal] = useState(false);
  // const [openFilesModal, setOpenFilesModal] = useState(false);
  // const [openPaymentConditionModal, setOpenPaymentConditionModal] =
  //   useState(false);
  // const [tempTermsFiles, setTempTermsFiles] = useState([]);
  // const [tempOtherFiles, setTempOtherFiles] = useState([]);
  // const [tempPaymentConditionFiles, setTempPaymentConditionFiles] = useState(
  //   []
  // );

  //------------existing---------

  const [productCategoryMaster, setProductCategoryMaster] = useState([]);
  const [filteredProductList, setFilteredProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [formProduct, setFormProduct] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);
  const [paymentTermMaster, setPaymentTermMaster] = useState([]);
  const [incotermsMaster, setIncotermsMaster] = useState([]);
  const [shippingMethodMaster, setShippingMethodMaster] = useState([]);
  const [allPortList, setAllPortList] = useState([]);
  const [formPortList, setFormPortList] = useState([]);
  const [packagingMaster, setPackagingMaster] = useState([]);
  const [filteredPackageSizes, setFilteredPackageSizes] = useState([]);

  const isViewMode = formMode === "view";
  const isEditMode = formMode === "edit";
  //--------------------------------------------

  //new changes
  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  const filePath = `public/media/amtpl/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  const [openDocumentVaultModal, setOpenDocumentVaultModal] = useState(false);
  const [documentVaultFiles, setDocumentVaultFiles] = useState([]);
  const [selectedVaultFile, setSelectedVaultFile] = useState(null);
  const [documentVaultUserFiles, setDocumentVaultUserFiles] = useState([]);
  const [documentCategoryMaster, setDocumentCategoryMaster] = useState([]);

  const [termsAndConditions, setTermsAndConditions] = useState([]);
  const [paymentConditionFiles, setPaymentConditionFiles] = useState([]);
  const [otherFiles, setOtherFiles] = useState([]);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const [openPaymentConditionModal, setOpenPaymentConditionModal] =
    useState(false);
  const [openFilesModal, setOpenFilesModal] = useState(false);
  const [tempTermsFiles, setTempTermsFiles] = useState([]);
  const [tempPaymentConditionFiles, setTempPaymentConditionFiles] = useState(
    []
  );
  const [tempOtherFiles, setTempOtherFiles] = useState([]);

  const [termsDocumentValut, setTermsDocumentValut] = useState(false);
  const [paymentDocumentValut, setPaymentDocumentValut] = useState(false);
  const [OtherFilesDocumentValut, setOtherFilesDocumentValut] = useState(false);
  const [selectedTermsVaultFile, setSelectedTermsVaultFile] = useState(null);
  const [selectedPaymentVaultFile, setSelectedPaymentVaultFile] =
    useState(null);

  const [requiredDocumentsMaster, setRequiredDocumentsMaster] = useState([]);
  const [selectedRequiredDocuments, setSelectedRequiredDocuments] = useState(
    []
  );

  const [openHistory, setOpenHistory] = useState(true);
  const ForHistory = (value) => {
    onHistoryClick?.(value);
    console.log(value, "dddddddddddddd");
    setOpenHistory(true);
  };
  const ForHistoryoff = () => {
    setOpenHistory(false);
  };

  const [openFinanceRFQModal, setOpenFinanceRFQModal] = useState(false);
  const handleOpenFinanceRFQModal = useCallback(() => {
    loadBankList();
    setOpenFinanceRFQModal(true);
  }, []);

  const handleCloseFinanceRFQModal = useCallback(() => {
    setOpenFinanceRFQModal(false);
  }, []);

  const [bankList, setBankList] = useState([]);
  const loadBankList = useCallback(async () => {
    setLoading(true);
    try {

      const [allBanks] = await Promise.all([
        searchfetchQueries({
          target: "listBankMaster",
          userOrder: "BankName",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      console.log(allBanks);
      setBankList(allBanks);

    } catch (error) {
      console.error("Error loading bank list: ", error);
      setBankList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const parseProductPackaging = (packagingString) => {
    try {
      const cleanedString = packagingString.replace(/[{}]/g, "");
      const keyValuePairs = cleanedString.split(", ").reduce((acc, pair) => {
        const [key, value] = pair.split("=");
        acc[key] = value;
        return acc;
      }, {});
      return { item: keyValuePairs.item || "", size: keyValuePairs.size || "" };
    } catch (error) {
      console.error("Error parsing ProductPackaging:", error);
      return { item: "", size: "" };
    }
  };
  //-------------

  //Add Finance RFQ changes -- before this state is working perfectly---
  const [addFinanceRFQ, setAddFinanceRFQ] = useState(false);
  const [financeInstrument, setFinanceInstrument] = useState("");
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [openFinancePopup, setOpenFinancePopup] = useState(false);
  const handleAddFinanceRFQChange = useCallback(
    (e) => {
      if (!isViewMode) {
        const isChecked = e.target.checked;
        setAddFinanceRFQ(isChecked);
        if (isChecked) {
          loadBankList();
          setOpenFinancePopup(true); // Open the finance popup modal
        } else {
          setOpenFinancePopup(false); // Close the modal
          setFinanceInstrument(""); // Reset finance instrument
          setSelectedBanks([]); // Reset selected banks
        }
      }
    },
    [
      setAddFinanceRFQ,
      setOpenFinancePopup,
      setFinanceInstrument,
      setSelectedBanks,
      isViewMode,
    ]
  );

  const handleFinancePopupConfirm = useCallback(() => {
    if (!financeInstrument) {
      setModal({
        show: true,
        type: "error",
        title: "Validation Error",
        message: "Please select a finance instrument.",
        autoClose: false,
      });
      return;
    }
    if (selectedBanks.length === 0) {
      setModal({
        show: true,
        type: "error",
        title: "Validation Error",
        message: "Please select at least one bank.",
        autoClose: false,
      });
      return;
    }
    console.log("financeInstrument@@@", financeInstrument, selectedBanks);
    setOpenFinancePopup(false);
  }, [financeInstrument, selectedBanks, setModal]);

  const handleFinancePopupCancel = useCallback(() => {
    setOpenFinancePopup(false);
    setAddFinanceRFQ(false);
    setFinanceInstrument("");
    setSelectedBanks([]);
  }, []);

  const handleFinanceInstrumentChange = useCallback((e) => {
    setFinanceInstrument(e.target.value);
  }, []);

  const handleBankSelectionChange = useCallback((e) => {
    setSelectedBanks(e.target.value);
  }, []);

  //----------------end add finance rfq changes------

  // const loadProductCategories = useCallback(async () => {
  //   setLoading(true);
  //   try {

  //       const [allProductCats] = await Promise.all([
  //         searchfetchQueries({
  //           target: "listProductCategory",
  //           userOrder: "CategoryName",
  //           rowStart: 0,
  //           pageSize: 100,
  //         }),
  //       ]);
  //       setProductCategoryMaster(allProductCats);

  //   } catch (error) {
  //     console.error("Error loading product categories: ", error);
  //     setProductCategoryMaster([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [setLoading]);

  const loadProducts = useCallback(
    async (productCategoryId) => {
      setLoading(true);

      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductCategoryID === productCategoryId
        );
        setFilteredProductList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
        setFilteredProductList([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductName === productName
        );
        setProductGradeList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allProductMaster]
  );

  const loadFormProductInfo = useCallback(
    (productName, grade) => {
      const matching = allProductMaster.find(
        (p) => p.ProductName === productName && p.Grade === grade
      );
      if (matching) {
        console.log("matching@", matching);
        setFormProduct(matching); // Mimic original .items[0]
        setHsCode(matching.HsCode || "");
        setVariety(matching.Variety || "");
      } else {
        setFormProduct([]);
        setHsCode("");
        setVariety("");
      }
    },
    [allProductMaster]
  );

  const loadFormPorts = useCallback(
    async (country) => {
      setLoading(true);
      try {
        const matchingPort = allPortList.filter((p) => p.Subtype === country);
        console.log("matchingPort@@", matchingPort);
        setFormPortList(matchingPort);
      } catch (error) {
        console.error("Error loading ports: ", error);
        setFormPortList([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allPortList]
  );


  function groupByType(items) {
    return items.reduce((acc, cur) => {
      const type = cur.Type;
      if (!acc[type]) acc[type] = [];
      acc[type].push(cur);
      return acc;
    }, {});
  }

  const loadAllDropdowns = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 100000,
      });

      const items = response.items ?? [];

      const groups = groupByType(items);

      setCountryMaster(groups.Country ?? []);
      setPaymentTermMaster(groups.paymentTerms ?? []);
      setIncotermsMaster(groups.Incoterms ?? []);
      setPackagingMaster(groups.packaging ?? []);
      setAllPortList(groups.port ?? []);
      setShippingMethodMaster(groups.shippingMethod ?? []);
      setDocumentCategoryMaster(groups.DocCategory ?? []);
      setRequiredDocumentsMaster(groups.RfqDoc ?? []);
    } catch (err) {
      console.error("Failed to load dropdown options:", err);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Could not load dropdown lists. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const loadPackageSizes = useCallback(
    (selectedPackaging) => {
      console.log("selectedPackaging@@", selectedPackaging);
      const filteredSizes = packagingMaster.filter(
        (item) => item.Subtype === selectedPackaging
      );
      setFilteredPackageSizes(filteredSizes);
    },
    [packagingMaster]
  );

  const handleTabChange = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  const validateForm = useCallback(() => {
    const newErrors = {};
    const today = dayjs().startOf("day");

    // RFQ Information validation
    if (!title) newErrors.title = "RFQ Title is required";
    if (!validUntil) {
      newErrors.validUntil = "Valid until date is required";
    } else if (!dayjs(validUntil).isValid()) {
      newErrors.validUntil = "Invalid date format";
    } else if (dayjs(validUntil).isBefore(today)) {
      newErrors.validUntil = "Valid until must be a future date";
    }

    // Commodity Details validation
    if (!category) newErrors.category = "Category is required";
    if (!product) newErrors.product = "Product is required";
    if (!grade) newErrors.grade = "Grade is required";

    // Quantity & Packaging validation
    if (!requestedQuantity) {
      newErrors.requestedQuantity = "Requested quantity is required";
    } else if (isNaN(requestedQuantity) || Number(requestedQuantity) <= 0) {
      newErrors.requestedQuantity =
        "Requested quantity must be a positive number";
    }

    // Delivery Terms validation
    if (!destination) newErrors.destination = "Destination country is required";
    if (!deliveryPort) newErrors.deliveryPort = "Delivery port is required";
    if (!deliveryPeriodFrom) {
      newErrors.deliveryPeriodFrom = "Delivery start date is required";
    } else if (!dayjs(deliveryPeriodFrom).isValid()) {
      newErrors.deliveryPeriodFrom = "Invalid date format";
    } else if (dayjs(deliveryPeriodFrom).isBefore(today) && !isEditMode) {
      newErrors.deliveryPeriodFrom =
        "Delivery start date cannot be in the past";
    }
    if (!deliveryPeriodTill) {
      newErrors.deliveryPeriodTill = "Delivery end date is required";
    } else if (!dayjs(deliveryPeriodTill).isValid()) {
      newErrors.deliveryPeriodTill = "Invalid date format";
    } else if (
      deliveryPeriodFrom &&
      dayjs(deliveryPeriodTill).isBefore(dayjs(deliveryPeriodFrom))
    ) {
      newErrors.deliveryPeriodTill =
        "Delivery end date must be after start date";
    }

    // Pricing/Payment/Guarantee validation
    if (!priceOffered) {
      newErrors.priceOffered = "Price offered is required";
    } else if (isNaN(priceOffered) || Number(priceOffered) <= 0) {
      newErrors.priceOffered = "Price offered must be a positive number";
    }
    console.log("newErrors@@", newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [
    title,
    validUntil,
    category,
    product,
    grade,
    requestedQuantity,
    destination,
    deliveryPort,
    deliveryPeriodFrom,
    deliveryPeriodTill,
    priceOffered,
    isEditMode,
  ]);

  const loadPaymentConditions = useCallback(async (requirementsID) => {
    try {
      const response = await fetchData({
        target: "listPaymentConditions",
        userOrder: "PaymentConditionsID",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { RequirementsID: requirementsID },
      });
      return response.items || [];
    } catch (error) {
      console.error("Error loading payment conditions:", error);
      return [];
    }
  }, []);

  const loadRequirementProductInfo = useCallback(async (requirementsID) => {
    try {
      const response = await fetchData({
        target: "listRequirementProductInfo",
        userOrder: "RequirementProductInfoID",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { RequirementsID: requirementsID },
      });
      return response.items || [];
    } catch (error) {
      console.error("Error loading requirement product info:", error);
      return [];
    }
  }, []);

  const handleSubmit3 = async () => {
    console.log("handleSubmit addFinanceRFQ@@rr", addFinanceRFQ);
    console.log("handleSubmit financeInstrument@@", financeInstrument);
    console.log("handleSubmit selectedBanks@@", selectedBanks);

    if (addFinanceRFQ) {
      console.log("need to configure for submission after confirmation.");
      setModal({
        show: true,
        type: "warning",
        title: "Are you sure?",
        message: "Do you want to Sign Out?",
        isConfirm: true,
        onConfirm: async () => {
          console.log("onConfirm triggered");
          setModal((prev) => ({ ...prev, show: false }));
        },
        onCancel: () => {
          console.log("onCancel triggered");
          setModal((prev) => ({ ...prev, show: false }));
        },
      });
    }
  };
  const handleSubmit = async () => {
    console.log("handleSubmit addFinanceRFQ@@", addFinanceRFQ);
    console.log("handleSubmit financeInstrument@@", financeInstrument);
    console.log("handleSubmit selectedBanks@@", selectedBanks);
    console.log('formProduct@@', formProduct.ProductID);
    // return;

    if (addFinanceRFQ) {
      console.log("need to configure for submission after confirmation.");
      setModal({
        show: true,
        type: "confirm",
        title: "Confirm Submission",
        message: "Are you sure you want to submit this Finance RFQ?",
        isConfirm: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Skip",
        onConfirm: async () => {
          // Finance RFQ submission logic
          if (!validateForm()) {
            setModal({
              show: true,
              type: "error",
              title: "Validation Error",
              message:
                "Please correct the errors in the form before submitting.",
              autoClose: false,
            });
            return;
          }

          let insertedRequirementsID = null;
          const insertedPaymentConditionsIDs = [];
          setSubmitted(true);
          setLoading(true);

          try {
            const packageingValue = {
              item: productPackaging,
              size: packageSize,
            };
            const curreDate = new Date();
            const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
            const reqCount = totalItems + 1;
            const reqNumber = reqNoDate + reqCount;

            const requestedQuantityValue = parseInt(requestedQuantity || 0);
            const requestedProductID = formProduct.ProductID || "";
            const categoryValue = formProduct.ProductCategoryID || "";
            const productType = "";
            const priceOfferedValue = priceOffered || "0.00";
            const deliveryPeriodTillValue = deliveryPeriodTill || "";
            const deliveryPeriodFromValue = deliveryPeriodFrom || "";
            const validUntilValue = validUntil || "";
            const incotermValue = incoterm || "";
            const destinationCountry = destination || "";
            const deliveryPortValue = deliveryPort || "";
            const locationsValue = destinationCountry + "~" + deliveryPortValue;
            const originCountryValue = origin || "";

            let gpEmail = activeUser;
            let recordStatus = "In Review";
            if (selectedRFQ) {
              recordStatus = selectedRFQ.Status;
            }
            const selectedDocsString = selectedRequiredDocuments.join(",");

            if (isEditMode) {
              if (recordStatus === "Rejected") recordStatus = "In Review";

              const formattedPakageingValue = `{${Object.entries(
                packageingValue
              )
                .map(([key, value]) => `${key}=${value}`)
                .join(", ")}}`;
              const requirementsInput = {
                RequirementsID: selectedRFQ.RequirementsID,
              };

              if (requestedQuantityValue !== selectedRFQ.Quantity) {
                requirementsInput.Quantity = requestedQuantityValue;
                requirementsInput.RequestedQuantity = requestedQuantityValue;
              }
              if (requestedProductID !== selectedRFQ.ProductID) {
                requirementsInput.ProductID = requestedProductID;
              }
              if (priceOfferedValue !== selectedRFQ.Price) {
                requirementsInput.Price = priceOfferedValue;
              }

              if (
                validUntilValue !==
                dayjs(selectedRFQ.ValidUntil).format("YYYY-MM-DD")
              ) {
                requirementsInput.ValidUntil = validUntilValue;
              }
              if (incotermValue !== selectedRFQ.Incoterm) {
                requirementsInput.Incoterm = incotermValue;
              }
              if (locationsValue !== selectedRFQ.DeliveryLocation) {
                requirementsInput.DeliveryLocation = locationsValue;
              }
              if (
                deliveryPeriodFromValue !==
                dayjs(selectedRFQ.DeliveryPeriodFrom).format("YYYY-MM-DD")
              ) {
                requirementsInput.DeliveryPeriodFrom = deliveryPeriodFromValue;
              }
              if (
                deliveryPeriodTillValue !==
                dayjs(selectedRFQ.DeliveryPeriodTill).format("YYYY-MM-DD")
              ) {
                requirementsInput.DeliveryPeriodTill = deliveryPeriodTillValue;
                requirementsInput.DeliveryDate = deliveryPeriodTillValue;
              }
              if (originCountryValue !== selectedRFQ.OriginCountry) {
                requirementsInput.OriginCountry = originCountryValue;
              }
              if (formattedPakageingValue !== selectedRFQ.ProductPackaging) {
                requirementsInput.ProductPackaging = packageingValue;
              }
              if (priceOfferedValue !== selectedRFQ.PriceOffered) {
                requirementsInput.PriceOffered = priceOfferedValue;
              }
              if (recordStatus !== selectedRFQ.Status) {
                requirementsInput.Status = recordStatus;
              }
              if (title !== selectedRFQ.Title) {
                requirementsInput.Title = title;
              }
              if (hsCode !== selectedRFQ.HsCode) {
                requirementsInput.HsCode = hsCode;
              }
              if (variety !== selectedRFQ.Variety) {
                requirementsInput.Variety = variety;
              }
              if (productSpecifications !== selectedRFQ.ProductSpecifications) {
                requirementsInput.ProductSpecifications = productSpecifications;
              }
              if (
                additionalProductNotes !== selectedRFQ.AdditionalProductNotes
              ) {
                requirementsInput.AdditionalProductNotes =
                  additionalProductNotes;
              }
              if (
                additionalPackagingNotes !==
                selectedRFQ.AdditionalPackagingNotes
              ) {
                requirementsInput.AdditionalPackagingNotes =
                  additionalPackagingNotes;
              }
              if (
                shippingMethodPreference !==
                selectedRFQ.ShippingMethodPreference
              ) {
                requirementsInput.ShippingMethodPreference =
                  shippingMethodPreference;
              }
              if (
                partialDeliveryAllowed !== selectedRFQ.PartialDeliveryAllowed
              ) {
                requirementsInput.PartialDeliveryAllowed =
                  partialDeliveryAllowed;
              }
              if (
                additionalLogisticsNotes !==
                selectedRFQ.AdditionalLogisticsNotes
              ) {
                requirementsInput.AdditionalLogisticsNotes =
                  additionalLogisticsNotes;
              }
              if (
                unloadingResponsibility !== selectedRFQ.UnloadingResponsibility
              ) {
                requirementsInput.UnloadingResponsibility =
                  unloadingResponsibility;
              }
              if (transshipmentAllowed !== selectedRFQ.TransshipmentAllowed) {
                requirementsInput.TransshipmentAllowed = transshipmentAllowed;
              }
              if (
                preferredPaymentMethod !== selectedRFQ.PreferredPaymentMethod
              ) {
                requirementsInput.PreferredPaymentMethod =
                  preferredPaymentMethod;
              }
              if (currency !== selectedRFQ.Currency) {
                requirementsInput.Currency = currency;
              }
              if (paymentTimeline !== selectedRFQ.PaymentTimeline) {
                requirementsInput.PaymentTimeline = paymentTimeline;
              }
              if (
                specialInstructionsSuppliers !==
                selectedRFQ.SpecialInstructionsSuppliers
              ) {
                requirementsInput.SpecialInstructionsSuppliers =
                  specialInstructionsSuppliers;
              }
              if (
                qualityInspectionRequired !==
                selectedRFQ.QualityInspectionRequired
              ) {
                requirementsInput.QualityInspectionRequired =
                  qualityInspectionRequired;
              }
              if (internalComments !== selectedRFQ.InternalComments) {
                requirementsInput.InternalComments = internalComments;
              }
              if (
                requiredSupplierCertifications !==
                selectedRFQ.RequiredSupplierCertifications
              ) {
                requirementsInput.RequiredSupplierCertifications =
                  requiredSupplierCertifications;
              }

              if (selectedDocsString !== selectedRFQ.RequiredDocuments) {
                requirementsInput.RequiredDocuments = selectedDocsString;
              }
              let cpt = comparisonCriteriaPriority.join(", ");
              if (cpt !== selectedRFQ.ComparisonCriteriaPriority) {
                requirementsInput.ComparisonCriteriaPriority = cpt;
              }

              if (Object.keys(requirementsInput).length > 1) {
                const body = {
                  target: "updateRequirements",
                  requirementsInput,
                };

                await postQuery(body);
              }

              const paymentConditions = await loadPaymentConditions(
                selectedRFQ.RequirementsID
              );
              const requirementProductInfo = await loadRequirementProductInfo(
                selectedRFQ.RequirementsID
              );

              await Promise.all([
                ...paymentConditions.map(async (pc) => {
                  const bodyDelPC = {
                    target: "deletePaymentConditions",
                    PaymentConditionsID: pc.PaymentConditionsID,
                  };
                  await postQuery(bodyDelPC);
                }),
                ...requirementProductInfo.map(async (pi) => {
                  const bodyDelPI = {
                    target: "deleteRequirementProductInfo",
                    RequirementProductInfoID: pi.RequirementProductInfoID,
                  };
                  await postQuery(bodyDelPI);
                }),
              ]);

              const bodyProductInfo = {
                target: "createRequirementProductInfo",
                requirementProductInfoInput: {
                  RequirementProductInfoID: uuidv4(),
                  RequirementsID: selectedRFQ.RequirementsID,
                  Category: categoryValue,
                  ProductID: requestedProductID,
                  ProductTypeID: productType,
                  Deleted: 0,
                },
              };
              await postQuery(bodyProductInfo);

              for (const file of paymentConditionFiles) {
                let uploadedFileName = null;
                if (file instanceof File && !file?.PaymentOptions) {
                  const fileresult = await uploadVideoToS3(file);
                  if (!fileresult?.fileName) continue;
                  uploadedFileName = fileresult.fileName;
                } else if (file?.PaymentOptions) {
                  uploadedFileName = file.PaymentOptions;
                }

                if (!uploadedFileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyPC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: selectedRFQ.RequirementsID,
                    PaymentOptions: uploadedFileName,
                    TermsConditionsFilePath: "",
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyPC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of termsAndConditions) {
                let uploadedFileName = null;
                if (file instanceof File) {
                  const fileresult = await uploadVideoToS3(file);
                  if (!fileresult?.fileName) continue;
                  uploadedFileName = fileresult.fileName;
                } else {
                  uploadedFileName = file.name;
                }

                if (!uploadedFileName) continue;
                const paymentConditionsID = uuidv4();
                const bodyTC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: selectedRFQ.RequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: uploadedFileName,
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyTC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of otherFiles) {
                let uploadedFileName = null;
                if (file instanceof File) {
                  const fileresult = await uploadVideoToS3(file);
                  if (!fileresult?.fileName) continue;
                  uploadedFileName = fileresult.fileName;
                } else {
                  uploadedFileName = file.name;
                }

                if (!uploadedFileName) continue;
                const paymentConditionsID = uuidv4();
                const bodyOther = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: selectedRFQ.RequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: "",
                    OthersFilePath: uploadedFileName,
                    Deleted: 0,
                  },
                };
                await postQuery(bodyOther);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              const bodyRTH = {
                target: "createRequirementTxnHistory",
                requirementTxnHistoryInput: {
                  RequirementTxnHistoryID: uuidv4(),
                  RequirementsID: selectedRFQ.RequirementsID,
                  ActionedByEmail: activeUser,
                  Status: recordStatus,
                  Deleted: 0,
                },
              };
              await postQuery(bodyRTH);

              setModal({
                show: true,
                type: "success",
                title: "Success!",
                message: "RFQ updated successfully.",
                autoClose: false,
                nextAction: () => {
                  navigate("/global-partner/rfqoffers");
                  setIsFormVisible(false);
                  searchRFQs(searchValues);
                },
              });
            } else {
              const body = {
                target: "createRequirements",
                ExtraInfo: {
                  ProductName: product,
                  Grade: grade,
                },
                requirementsInput: {
                  RequirementsID: uuidv4(),
                  RequirementNumber: reqNumber,
                  GPEmailID: gpEmail,
                  BuyerEmailID: " ",
                  CreatedByEmailID: activeUser,
                  ProductID: requestedProductID,
                  Quantity: requestedQuantityValue,
                  Price: priceOfferedValue,
                  DeliveryDate: deliveryPeriodTillValue,
                  RequirementDate: dayjs(curreDate).format("YYYY-MM-DD"),
                  MarketPlacement: "No",
                  ValidUntil: validUntilValue,
                  Incoterm: incotermValue,
                  DeliveryLocation: locationsValue,
                  DeliveryPeriodFrom: deliveryPeriodFromValue,
                  DeliveryPeriodTill: deliveryPeriodTillValue,
                  OriginCountry: originCountryValue,
                  ProductPackaging: packageingValue,
                  RequestedQuantity: requestedQuantityValue,
                  PriceOffered: priceOfferedValue,
                  Status: recordStatus,
                  CategoryType: "rfq",
                  Deleted: 0,
                  Title: title,
                  CreateDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
                  SubmitedDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
                  HsCode: hsCode,
                  Variety: variety,
                  ProductSpecifications: productSpecifications,
                  AdditionalProductNotes: additionalProductNotes,
                  AdditionalPackagingNotes: additionalPackagingNotes,
                  ShippingMethodPreference: shippingMethodPreference,
                  PartialDeliveryAllowed: partialDeliveryAllowed,
                  AdditionalLogisticsNotes: additionalLogisticsNotes,
                  UnloadingResponsibility: unloadingResponsibility,
                  TransshipmentAllowed: transshipmentAllowed,
                  PreferredPaymentMethod: preferredPaymentMethod,
                  Currency: currency,
                  PaymentTimeline: paymentTimeline,
                  SpecialInstructionsSuppliers: specialInstructionsSuppliers,
                  QualityInspectionRequired: qualityInspectionRequired,
                  InternalComments: internalComments,
                  RequiredSupplierCertifications:
                    requiredSupplierCertifications,
                  ComparisonCriteriaPriority:
                    comparisonCriteriaPriority.join(", "),
                  RequiredDocuments: selectedDocsString,
                },
              };

              const result = await postQuery(body);
              if (!result || !result.items)
                throw new Error("Failed to create RFQ.");
              insertedRequirementsID = result.items.RequirementsID;

              const bodyProductInfo = {
                target: "createRequirementProductInfo",
                requirementProductInfoInput: {
                  RequirementProductInfoID: uuidv4(),
                  RequirementsID: insertedRequirementsID,
                  Category: categoryValue,
                  ProductID: requestedProductID,
                  ProductTypeID: productType,
                  Deleted: 0,
                },
              };
              await postQuery(bodyProductInfo);

              for (const file of paymentConditionFiles) {
                if (!file || !file.name) continue;
                const fileresult = await uploadVideoToS3(file);
                if (!fileresult?.fileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyPC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: insertedRequirementsID,
                    PaymentOptions: fileresult.fileName,
                    TermsConditionsFilePath: "",
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyPC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of termsAndConditions) {
                if (!file || !file.name) continue;
                const fileresult = await uploadVideoToS3(file);
                if (!fileresult?.fileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyTC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: insertedRequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: fileresult.fileName,
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyTC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of otherFiles) {
                if (!file || !file.name) continue;
                const fileresult = await uploadVideoToS3(file);
                if (!fileresult?.fileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyOther = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: insertedRequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: "",
                    OthersFilePath: fileresult.fileName,
                    Deleted: 0,
                  },
                };
                await postQuery(bodyOther);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              const bodyRTH = {
                target: "createRequirementTxnHistory",
                requirementTxnHistoryInput: {
                  RequirementTxnHistoryID: uuidv4(),
                  RequirementsID: insertedRequirementsID,
                  ActionedByEmail: activeUser,
                  Status: recordStatus,
                  Deleted: 0,
                },
              };
              await postQuery(bodyRTH);

              let totalFrqItems = 0;
              try {
                const bodyFinanceRfq = {
                  target: "listFinanceRfq",
                  userOrder: "RfqId",
                  rowStart: 0,
                  pageSize: 1,
                };
                const responseFinanceRfq = await fetchData(bodyFinanceRfq);
                totalFrqItems = responseFinanceRfq.total || 0;
              } catch (error) {
                console.error("Error loading RFQs: ", error);
                totalFrqItems = 0;
              }
              const defaultShipmentDate = dayjs(curreDate).format("YYYY-MM-DD");
              let Id = uuidv4();
              let RfqId = "";

              const reqCountFrq = totalFrqItems + 1;
              RfqId = reqNoDate + reqCountFrq;

              let LcAmountDerived = 0;
              LcAmountDerived =
                parseFloat(priceOfferedValue) *
                parseFloat(requestedQuantityValue);

              let rfqDeliveryLocation = locationsValue || "";
              let [rfqDeliveryCountry, rfqDeliveryPort] =
                rfqDeliveryLocation.split("~");

              let Title = title || " ";
              let Instrument = financeInstrument || " ";
              let ApplicantName =
                buyerInfo[0]?.FirstName + " " + buyerInfo[0]?.LastName;
              let BeneficiaryName = "Agropreneurs Market Technology Pvt Ltd";
              let LcAmount = parseFloat(LcAmountDerived) || 0;
              let Currency = "USD";
              let TypeOfLc = "Sight";
              let Incoterms = incotermValue || "n/a";
              let OriginCountry = originCountryValue || "n/a";
              let DestinationCountry = rfqDeliveryCountry || "n/a";
              let GoodsDescription = productSpecifications || "n/a";
              const requiredDocumentsStr = "Commercial Invoice,Bill of Lading";
              let ConfirmingBank = "n/a";
              let LcBankDetails = "n/a";
              let ExpiryDate = validUntilValue
                ? dayjs(validUntilValue).format("YYYY-MM-DD")
                : defaultShipmentDate;
              let ExpiryPlace = "n/a";
              let PaymentTerms = "LC at Sight";
              let TradeType = "Import";

              let selectedProduct = "";
              if (requestedProductID) {
                selectedProduct = allProductMaster.find(
                  (p) => p.ProductID === requestedProductID
                );
              }

              let ComodityDescription = selectedProduct
                ? selectedProduct.ProductName + "/" + selectedProduct.Grade
                : "" || "n/a";

              let Hscode = hsCode || "n/a";
              let BuyerName = buyerInfo[0]?.EmailID || "n/a";
              let BuyerCountry = buyerInfo[0]?.Country || "n/a";
              let SellerName = "Agropreneurs Market Technology Pvt Ltd";
              let SellerCountry = "India";
              let LoadingPort = "Kolkata";
              let DischargePort = rfqDeliveryPort || "n/a";
              let TradeIncoterms = incotermValue || "n/a";
              let ShipmentDate = deliveryPeriodFromValue
                ? dayjs(deliveryPeriodFromValue).format("YYYY-MM-DD")
                : defaultShipmentDate;
              let TradeValue = parseFloat(LcAmountDerived) || 0;
              let ConfirmingBankRequired = "N";
              let ConfirmationRequired = "N";
              let PartialShipmentAllowed = "Y";
              let TransshipmentAllowed = "Y";
              let InstrumentTerms = " ";
              let ConfirmationCharges = 0;
              let IssuanceCharges = 0;
              let InterestRateMargin = 0;
              let TenorOffered = " ";
              let AdditionalDocuments = " ";
              let SpecialClause = " ";
              let ResponseDeadlineBank = validUntilValue
                ? dayjs(validUntilValue).format("YYYY-MM-DD")
                : defaultShipmentDate;
              let PreferedFinanceRateType = " ";
              let MaxAcceptableCharges = " ";
              let AdditionalComments = " ";

              let proformaInvoiceFileRef = " ";
              let tradeDocsFileRef = " ";
              let kycDocsFileRef = " ";
              let proformaInvoiceFileRefUrl = " ";
              let tradeDocsFileRefUrl = " ";
              let kycDocsFileRefUrl = " ";
              LcBankDetails = selectedBanks
                .map(
                  (id) => bankList.find((bank) => bank.BankID === id)?.BankName
                )
                .join(", ");

              const financeRfqInput = {
                Id: Id,
                RfqId: RfqId,
                Title: Title,
                Instrument: Instrument,
                ApplicantName: ApplicantName,
                BeneficiaryName: BeneficiaryName,
                LcAmount: LcAmount,
                Currency: Currency,
                TypeOfLc: TypeOfLc,
                Incoterms: Incoterms,
                OriginCountry: OriginCountry,
                DestinationCountry: DestinationCountry,
                GoodsDescription: GoodsDescription,
                RequiredDocuments: requiredDocumentsStr,
                ConfirmingBank: ConfirmingBank,
                LcBankDetails: LcBankDetails,
                ExpiryDate: ExpiryDate,
                ExpiryPlace: ExpiryPlace,
                PaymentTerms: PaymentTerms,
                TradeType: TradeType,
                ComodityDescription: ComodityDescription,
                Hscode: Hscode,
                BuyerName: BuyerName,
                BuyerCountry: BuyerCountry,
                SellerName: SellerName,
                SellerCountry: SellerCountry,
                LoadingPort: LoadingPort,
                DischargePort: DischargePort,
                TradeIncoterms: TradeIncoterms,
                ShipmentDate: ShipmentDate,
                TradeValue: TradeValue,
                ConfirmingBankRequired: ConfirmingBankRequired,
                ConfirmationRequired: ConfirmationRequired,
                PartialShipmentAllowed: PartialShipmentAllowed,
                TransshipmentAllowed: TransshipmentAllowed,
                InstrumentTerms: InstrumentTerms,
                ConfirmationCharges: ConfirmationCharges,
                IssuanceCharges: IssuanceCharges,
                InterestRateMargin: InterestRateMargin,
                TenorOffered: TenorOffered,
                AdditionalDocuments: AdditionalDocuments,
                SpecialClause: SpecialClause,
                ProformaInvoiceFile: proformaInvoiceFileRef || "",
                TradeDocumentFile: tradeDocsFileRef || "",
                KycDocumentFile: kycDocsFileRef || "",
                ResponseDeadlineBank: ResponseDeadlineBank,
                PreferedFinanceRateType: PreferedFinanceRateType,
                MaxAcceptableCharges: MaxAcceptableCharges,
                AdditionalComments: AdditionalComments,
                CreatedBy: activeUser,
                Status: "Draft",
                TradeRfqID: insertedRequirementsID,
              };
              const bodyFinanceRfqCreate = {
                target: "createFinanceRfq",
                financeRfqInput,
              };
              const resultFinanceRfqCreate = await postQuery(
                bodyFinanceRfqCreate
              );
              if (!resultFinanceRfqCreate || !resultFinanceRfqCreate.items)
                throw new Error(`Failed to create finance RFQ.`);

              const selectedBanksData = selectedBanks.map((id) => ({
                BankID: id,
              }));
              const bankPromises = selectedBanksData.map(async (bank) => {
                const financeRfqBanksInput = {
                  FinanceRfqBankID: uuidv4(),
                  FinanceRfqID: resultFinanceRfqCreate.items.Id || Id,
                  BankID: bank.BankID,
                };
                const bankBody = {
                  target: "createFinanceRfqBanks",
                  financeRfqBanksInput,
                };
                await postQuery(bankBody);
              });

              await Promise.all(bankPromises).catch((error) => {
                console.error("Error creating FinanceRfqBanks:", error);
                throw new Error("Failed to associate banks with RFQ.");
              });

              setModal({
                show: true,
                type: "success",
                title: "Success!",
                message: "RFQ created successfully.",
                autoClose: false,
                nextAction: () => {
                  navigate("/global-partner/rfqoffers");
                  setIsFormVisible(false);
                  searchRFQs(searchValues);
                },
              });
            }
          } catch (error) {
            console.error("Submission error:", error);
            try {
              await Promise.all(
                insertedPaymentConditionsIDs.map(
                  async (paymentConditionsID) => {
                    const bodyDelPC = {
                      target: "deletePaymentConditions",
                      PaymentConditionsID: paymentConditionsID,
                    };
                    await postQuery(bodyDelPC);
                  }
                )
              );
              if (insertedRequirementsID) {
                const bodyDelR = {
                  target: "deleteRequirements",
                  RequirementsID: insertedRequirementsID,
                };
                await postQuery(bodyDelR);
              }
            } catch (rollbackError) {
              console.error("Rollback error:", rollbackError);
              setModal({
                show: true,
                type: "error",
                title: "Rollback Error!",
                message:
                  "Failed to clean up data after error. Please contact support.",
                autoClose: false,
              });
              setLoading(false);
              setSubmitted(false);
              return;
            }
            setModal({
              show: true,
              type: "error",
              title: "Error!",
              message: error.message || "Failed to submit RFQ.",
              autoClose: false,
            });
          } finally {
            setLoading(false);
            setSubmitted(false);
          }
        },
        onCancel: async () => {
          // If not confirmed, proceed with original else block
          if (!validateForm()) {
            setModal({
              show: true,
              type: "error",
              title: "Validation Error",
              message:
                "Please correct the errors in the form before submitting.",
              autoClose: false,
            });
            return;
          }

          let insertedRequirementsID = null;
          const insertedPaymentConditionsIDs = [];
          setSubmitted(true);
          setLoading(true);

          try {
            const packageingValue = {
              item: productPackaging,
              size: packageSize,
            };
            const curreDate = new Date();
            const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
            const reqCount = totalItems + 1;
            const reqNumber = reqNoDate + reqCount;

            const requestedQuantityValue = parseInt(requestedQuantity || 0);
            const requestedProductID = formProduct.ProductID || "";
            const categoryValue = formProduct.ProductCategoryID || "";
            const productType = "";
            const priceOfferedValue = priceOffered || "0.00";
            const deliveryPeriodTillValue = deliveryPeriodTill || "";
            const deliveryPeriodFromValue = deliveryPeriodFrom || "";
            const validUntilValue = validUntil || "";
            const incotermValue = incoterm || "";
            const destinationCountry = destination || "";
            const deliveryPortValue = deliveryPort || "";
            const locationsValue = destinationCountry + "~" + deliveryPortValue;
            const originCountryValue = origin || "";

            let gpEmail = activeUser;
            let recordStatus = "In Review";
            if (selectedRFQ) {
              recordStatus = selectedRFQ.Status;
            }
            const selectedDocsString = selectedRequiredDocuments.join(",");

            if (isEditMode) {
              if (recordStatus === "Rejected") recordStatus = "In Review";

              const formattedPakageingValue = `{${Object.entries(
                packageingValue
              )
                .map(([key, value]) => `${key}=${value}`)
                .join(", ")}}`;
              const requirementsInput = {
                RequirementsID: selectedRFQ.RequirementsID,
              };

              if (requestedQuantityValue !== selectedRFQ.Quantity) {
                requirementsInput.Quantity = requestedQuantityValue;
                requirementsInput.RequestedQuantity = requestedQuantityValue;
              }
              if (requestedProductID !== selectedRFQ.ProductID) {
                requirementsInput.ProductID = requestedProductID;
              }
              if (priceOfferedValue !== selectedRFQ.Price) {
                requirementsInput.Price = priceOfferedValue;
              }

              if (
                validUntilValue !==
                dayjs(selectedRFQ.ValidUntil).format("YYYY-MM-DD")
              ) {
                requirementsInput.ValidUntil = validUntilValue;
              }
              if (incotermValue !== selectedRFQ.Incoterm) {
                requirementsInput.Incoterm = incotermValue;
              }
              if (locationsValue !== selectedRFQ.DeliveryLocation) {
                requirementsInput.DeliveryLocation = locationsValue;
              }
              if (
                deliveryPeriodFromValue !==
                dayjs(selectedRFQ.DeliveryPeriodFrom).format("YYYY-MM-DD")
              ) {
                requirementsInput.DeliveryPeriodFrom = deliveryPeriodFromValue;
              }
              if (
                deliveryPeriodTillValue !==
                dayjs(selectedRFQ.DeliveryPeriodTill).format("YYYY-MM-DD")
              ) {
                requirementsInput.DeliveryPeriodTill = deliveryPeriodTillValue;
                requirementsInput.DeliveryDate = deliveryPeriodTillValue;
              }
              if (originCountryValue !== selectedRFQ.OriginCountry) {
                requirementsInput.OriginCountry = originCountryValue;
              }
              if (formattedPakageingValue !== selectedRFQ.ProductPackaging) {
                requirementsInput.ProductPackaging = packageingValue;
              }
              if (priceOfferedValue !== selectedRFQ.PriceOffered) {
                requirementsInput.PriceOffered = priceOfferedValue;
              }
              if (recordStatus !== selectedRFQ.Status) {
                requirementsInput.Status = recordStatus;
              }
              if (title !== selectedRFQ.Title) {
                requirementsInput.Title = title;
              }
              if (hsCode !== selectedRFQ.HsCode) {
                requirementsInput.HsCode = hsCode;
              }
              if (variety !== selectedRFQ.Variety) {
                requirementsInput.Variety = variety;
              }
              if (productSpecifications !== selectedRFQ.ProductSpecifications) {
                requirementsInput.ProductSpecifications = productSpecifications;
              }
              if (
                additionalProductNotes !== selectedRFQ.AdditionalProductNotes
              ) {
                requirementsInput.AdditionalProductNotes =
                  additionalProductNotes;
              }
              if (
                additionalPackagingNotes !==
                selectedRFQ.AdditionalPackagingNotes
              ) {
                requirementsInput.AdditionalPackagingNotes =
                  additionalPackagingNotes;
              }
              if (
                shippingMethodPreference !==
                selectedRFQ.ShippingMethodPreference
              ) {
                requirementsInput.ShippingMethodPreference =
                  shippingMethodPreference;
              }
              if (
                partialDeliveryAllowed !== selectedRFQ.PartialDeliveryAllowed
              ) {
                requirementsInput.PartialDeliveryAllowed =
                  partialDeliveryAllowed;
              }
              if (
                additionalLogisticsNotes !==
                selectedRFQ.AdditionalLogisticsNotes
              ) {
                requirementsInput.AdditionalLogisticsNotes =
                  additionalLogisticsNotes;
              }
              if (
                unloadingResponsibility !== selectedRFQ.UnloadingResponsibility
              ) {
                requirementsInput.UnloadingResponsibility =
                  unloadingResponsibility;
              }
              if (transshipmentAllowed !== selectedRFQ.TransshipmentAllowed) {
                requirementsInput.TransshipmentAllowed = transshipmentAllowed;
              }
              if (
                preferredPaymentMethod !== selectedRFQ.PreferredPaymentMethod
              ) {
                requirementsInput.PreferredPaymentMethod =
                  preferredPaymentMethod;
              }
              if (currency !== selectedRFQ.Currency) {
                requirementsInput.Currency = currency;
              }
              if (paymentTimeline !== selectedRFQ.PaymentTimeline) {
                requirementsInput.PaymentTimeline = paymentTimeline;
              }
              if (
                specialInstructionsSuppliers !==
                selectedRFQ.SpecialInstructionsSuppliers
              ) {
                requirementsInput.SpecialInstructionsSuppliers =
                  specialInstructionsSuppliers;
              }
              if (
                qualityInspectionRequired !==
                selectedRFQ.QualityInspectionRequired
              ) {
                requirementsInput.QualityInspectionRequired =
                  qualityInspectionRequired;
              }
              if (internalComments !== selectedRFQ.InternalComments) {
                requirementsInput.InternalComments = internalComments;
              }
              if (
                requiredSupplierCertifications !==
                selectedRFQ.RequiredSupplierCertifications
              ) {
                requirementsInput.RequiredSupplierCertifications =
                  requiredSupplierCertifications;
              }

              if (selectedDocsString !== selectedRFQ.RequiredDocuments) {
                requirementsInput.RequiredDocuments = selectedDocsString;
              }
              let cpt = comparisonCriteriaPriority.join(", ");
              if (cpt !== selectedRFQ.ComparisonCriteriaPriority) {
                requirementsInput.ComparisonCriteriaPriority = cpt;
              }

              if (Object.keys(requirementsInput).length > 1) {
                const body = {
                  target: "updateRequirements",
                  requirementsInput,
                };

                await postQuery(body);
              }

              const paymentConditions = await loadPaymentConditions(
                selectedRFQ.RequirementsID
              );
              const requirementProductInfo = await loadRequirementProductInfo(
                selectedRFQ.RequirementsID
              );

              await Promise.all([
                ...paymentConditions.map(async (pc) => {
                  const bodyDelPC = {
                    target: "deletePaymentConditions",
                    PaymentConditionsID: pc.PaymentConditionsID,
                  };
                  await postQuery(bodyDelPC);
                }),
                ...requirementProductInfo.map(async (pi) => {
                  const bodyDelPI = {
                    target: "deleteRequirementProductInfo",
                    RequirementProductInfoID: pi.RequirementProductInfoID,
                  };
                  await postQuery(bodyDelPI);
                }),
              ]);

              const bodyProductInfo = {
                target: "createRequirementProductInfo",
                requirementProductInfoInput: {
                  RequirementProductInfoID: uuidv4(),
                  RequirementsID: selectedRFQ.RequirementsID,
                  Category: categoryValue,
                  ProductID: requestedProductID,
                  ProductTypeID: productType,
                  Deleted: 0,
                },
              };
              await postQuery(bodyProductInfo);

              for (const file of paymentConditionFiles) {
                let uploadedFileName = null;
                if (file instanceof File && !file?.PaymentOptions) {
                  const fileresult = await uploadVideoToS3(file);
                  if (!fileresult?.fileName) continue;
                  uploadedFileName = fileresult.fileName;
                } else if (file?.PaymentOptions) {
                  uploadedFileName = file.PaymentOptions;
                }

                if (!uploadedFileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyPC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: selectedRFQ.RequirementsID,
                    PaymentOptions: uploadedFileName,
                    TermsConditionsFilePath: "",
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyPC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of termsAndConditions) {
                let uploadedFileName = null;
                if (file instanceof File) {
                  const fileresult = await uploadVideoToS3(file);
                  if (!fileresult?.fileName) continue;
                  uploadedFileName = fileresult.fileName;
                } else {
                  uploadedFileName = file.name;
                }

                if (!uploadedFileName) continue;
                const paymentConditionsID = uuidv4();
                const bodyTC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: selectedRFQ.RequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: uploadedFileName,
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyTC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of otherFiles) {
                let uploadedFileName = null;
                if (file instanceof File) {
                  const fileresult = await uploadVideoToS3(file);
                  if (!fileresult?.fileName) continue;
                  uploadedFileName = fileresult.fileName;
                } else {
                  uploadedFileName = file.name;
                }

                if (!uploadedFileName) continue;
                const paymentConditionsID = uuidv4();
                const bodyOther = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: selectedRFQ.RequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: "",
                    OthersFilePath: uploadedFileName,
                    Deleted: 0,
                  },
                };
                await postQuery(bodyOther);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              const bodyRTH = {
                target: "createRequirementTxnHistory",
                requirementTxnHistoryInput: {
                  RequirementTxnHistoryID: uuidv4(),
                  RequirementsID: selectedRFQ.RequirementsID,
                  ActionedByEmail: activeUser,
                  Status: recordStatus,
                  Deleted: 0,
                },
              };
              await postQuery(bodyRTH);

              setModal({
                show: true,
                type: "success",
                title: "Success!",
                message: "RFQ updated successfully.",
                autoClose: false,
                nextAction: () => {
                  navigate("/global-partner/rfqoffers");
                  setIsFormVisible(false);
                  searchRFQs(searchValues);
                },
              });
            } else {
              const body = {
                target: "createRequirements",
                requirementsInput: {
                  RequirementsID: uuidv4(),
                  RequirementNumber: reqNumber,
                  GPEmailID: gpEmail,
                  BuyerEmailID: " ",
                  CreatedByEmailID: activeUser,
                  ProductID: requestedProductID,
                  Quantity: requestedQuantityValue,
                  Price: priceOfferedValue,
                  DeliveryDate: deliveryPeriodTillValue,
                  RequirementDate: dayjs(curreDate).format("YYYY-MM-DD"),
                  MarketPlacement: "No",
                  ValidUntil: validUntilValue,
                  Incoterm: incotermValue,
                  DeliveryLocation: locationsValue,
                  DeliveryPeriodFrom: deliveryPeriodFromValue,
                  DeliveryPeriodTill: deliveryPeriodTillValue,
                  OriginCountry: originCountryValue,
                  ProductPackaging: packageingValue,
                  RequestedQuantity: requestedQuantityValue,
                  PriceOffered: priceOfferedValue,
                  Status: recordStatus,
                  CategoryType: "rfq",
                  Deleted: 0,
                  Title: title,
                  CreateDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
                  SubmitedDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
                  HsCode: hsCode,
                  Variety: variety,
                  ProductSpecifications: productSpecifications,
                  AdditionalProductNotes: additionalProductNotes,
                  AdditionalPackagingNotes: additionalPackagingNotes,
                  ShippingMethodPreference: shippingMethodPreference,
                  PartialDeliveryAllowed: partialDeliveryAllowed,
                  AdditionalLogisticsNotes: additionalLogisticsNotes,
                  UnloadingResponsibility: unloadingResponsibility,
                  TransshipmentAllowed: transshipmentAllowed,
                  PreferredPaymentMethod: preferredPaymentMethod,
                  Currency: currency,
                  PaymentTimeline: paymentTimeline,
                  SpecialInstructionsSuppliers: specialInstructionsSuppliers,
                  QualityInspectionRequired: qualityInspectionRequired,
                  InternalComments: internalComments,
                  RequiredSupplierCertifications:
                    requiredSupplierCertifications,
                  ComparisonCriteriaPriority:
                    comparisonCriteriaPriority.join(", "),
                  RequiredDocuments: selectedDocsString,
                },
              };

              const result = await postQuery(body);
              if (!result || !result.items)
                throw new Error("Failed to create RFQ.");
              insertedRequirementsID = result.items.RequirementsID;

              const bodyProductInfo = {
                target: "createRequirementProductInfo",
                requirementProductInfoInput: {
                  RequirementProductInfoID: uuidv4(),
                  RequirementsID: insertedRequirementsID,
                  Category: categoryValue,
                  ProductID: requestedProductID,
                  ProductTypeID: productType,
                  Deleted: 0,
                },
              };
              await postQuery(bodyProductInfo);

              for (const file of paymentConditionFiles) {
                if (!file || !file.name) continue;
                const fileresult = await uploadVideoToS3(file);
                if (!fileresult?.fileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyPC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: insertedRequirementsID,
                    PaymentOptions: fileresult.fileName,
                    TermsConditionsFilePath: "",
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyPC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of termsAndConditions) {
                if (!file || !file.name) continue;
                const fileresult = await uploadVideoToS3(file);
                if (!fileresult?.fileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyTC = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: insertedRequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: fileresult.fileName,
                    OthersFilePath: "",
                    Deleted: 0,
                  },
                };
                await postQuery(bodyTC);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              for (const file of otherFiles) {
                if (!file || !file.name) continue;
                const fileresult = await uploadVideoToS3(file);
                if (!fileresult?.fileName) continue;

                const paymentConditionsID = uuidv4();
                const bodyOther = {
                  target: "createPaymentConditions",
                  paymentConditionsInput: {
                    PaymentConditionsID: paymentConditionsID,
                    RequirementsID: insertedRequirementsID,
                    PaymentOptions: "",
                    TermsConditionsFilePath: "",
                    OthersFilePath: fileresult.fileName,
                    Deleted: 0,
                  },
                };
                await postQuery(bodyOther);
                insertedPaymentConditionsIDs.push(paymentConditionsID);
              }

              const bodyRTH = {
                target: "createRequirementTxnHistory",
                requirementTxnHistoryInput: {
                  RequirementTxnHistoryID: uuidv4(),
                  RequirementsID: insertedRequirementsID,
                  ActionedByEmail: activeUser,
                  Status: recordStatus,
                  Deleted: 0,
                },
              };
              await postQuery(bodyRTH);

              setModal({
                show: true,
                type: "success",
                title: "Success!",
                message: "RFQ created successfully.",
                autoClose: false,
                nextAction: () => {
                  navigate("/global-partner/rfqoffers");
                  setIsFormVisible(false);
                  searchRFQs(searchValues);
                },
              });
            }
          } catch (error) {
            console.error("Submission error:", error);
            try {
              await Promise.all(
                insertedPaymentConditionsIDs.map(
                  async (paymentConditionsID) => {
                    const bodyDelPC = {
                      target: "deletePaymentConditions",
                      PaymentConditionsID: paymentConditionsID,
                    };
                    await postQuery(bodyDelPC);
                  }
                )
              );
              if (insertedRequirementsID) {
                const bodyDelR = {
                  target: "deleteRequirements",
                  RequirementsID: insertedRequirementsID,
                };
                await postQuery(bodyDelR);
              }
            } catch (rollbackError) {
              console.error("Rollback error:", rollbackError);
              setModal({
                show: true,
                type: "error",
                title: "Rollback Error!",
                message:
                  "Failed to clean up data after error. Please contact support.",
                autoClose: false,
              });
              setLoading(false);
              setSubmitted(false);
              return;
            }
            setModal({
              show: true,
              type: "error",
              title: "Error!",
              message: error.message || "Failed to submit RFQ.",
              autoClose: false,
            });
          } finally {
            setLoading(false);
            setSubmitted(false);
          }
        },
      });
    } else {
      if (!validateForm()) {
        setModal({
          show: true,
          type: "error",
          title: "Validation Error",
          message: "Please correct the errors in the form before submitting.",
          autoClose: false,
        });
        return;
      }

      let insertedRequirementsID = null;
      const insertedPaymentConditionsIDs = [];
      setSubmitted(true);
      setLoading(true);

      try {
        const packageingValue = { item: productPackaging, size: packageSize };
        const curreDate = new Date();
        const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
        const reqCount = totalItems + 1;
        const reqNumber = reqNoDate + reqCount;

        const requestedQuantityValue = parseInt(requestedQuantity || 0);
        const requestedProductID = formProduct.ProductID || "";
        const categoryValue = formProduct.ProductCategoryID || "";
        const productType = "";
        const priceOfferedValue = priceOffered || "0.00";
        const deliveryPeriodTillValue = deliveryPeriodTill || "";
        const deliveryPeriodFromValue = deliveryPeriodFrom || "";
        const validUntilValue = validUntil || "";
        const incotermValue = incoterm || "";
        const destinationCountry = destination || "";
        const deliveryPortValue = deliveryPort || "";
        const locationsValue = destinationCountry + "~" + deliveryPortValue;
        const originCountryValue = origin || "";

        let gpEmail = activeUser;
        let recordStatus = "In Review";
        if (selectedRFQ) {
          recordStatus = selectedRFQ.Status;
        }
        const selectedDocsString = selectedRequiredDocuments.join(",");

        if (isEditMode) {
          if (recordStatus === "Rejected") recordStatus = "In Review";
          if (recordStatus === "Draft") recordStatus = "In Review";

          const formattedPakageingValue = `{${Object.entries(packageingValue)
            .map(([key, value]) => `${key}=${value}`)
            .join(", ")}}`;
          const requirementsInput = {
            RequirementsID: selectedRFQ.RequirementsID,
          };

          if (requestedQuantityValue !== selectedRFQ.Quantity) {
            requirementsInput.Quantity = requestedQuantityValue;
            requirementsInput.RequestedQuantity = requestedQuantityValue;
          }
          if (requestedProductID !== selectedRFQ.ProductID) {
            requirementsInput.ProductID = requestedProductID;
          }
          if (priceOfferedValue !== selectedRFQ.Price) {
            requirementsInput.Price = priceOfferedValue;
          }

          if (
            validUntilValue !==
            dayjs(selectedRFQ.ValidUntil).format("YYYY-MM-DD")
          ) {
            requirementsInput.ValidUntil = validUntilValue;
          }
          if (incotermValue !== selectedRFQ.Incoterm) {
            requirementsInput.Incoterm = incotermValue;
          }
          if (locationsValue !== selectedRFQ.DeliveryLocation) {
            requirementsInput.DeliveryLocation = locationsValue;
          }
          if (
            deliveryPeriodFromValue !==
            dayjs(selectedRFQ.DeliveryPeriodFrom).format("YYYY-MM-DD")
          ) {
            requirementsInput.DeliveryPeriodFrom = deliveryPeriodFromValue;
          }
          if (
            deliveryPeriodTillValue !==
            dayjs(selectedRFQ.DeliveryPeriodTill).format("YYYY-MM-DD")
          ) {
            requirementsInput.DeliveryPeriodTill = deliveryPeriodTillValue;
            requirementsInput.DeliveryDate = deliveryPeriodTillValue;
          }
          if (originCountryValue !== selectedRFQ.OriginCountry) {
            requirementsInput.OriginCountry = originCountryValue;
          }
          if (formattedPakageingValue !== selectedRFQ.ProductPackaging) {
            requirementsInput.ProductPackaging = packageingValue;
          }
          if (priceOfferedValue !== selectedRFQ.PriceOffered) {
            requirementsInput.PriceOffered = priceOfferedValue;
          }
          if (recordStatus !== selectedRFQ.Status) {
            requirementsInput.Status = recordStatus;
          }
          if (title !== selectedRFQ.Title) {
            requirementsInput.Title = title;
          }
          if (hsCode !== selectedRFQ.HsCode) {
            requirementsInput.HsCode = hsCode;
          }
          if (variety !== selectedRFQ.Variety) {
            requirementsInput.Variety = variety;
          }
          if (productSpecifications !== selectedRFQ.ProductSpecifications) {
            requirementsInput.ProductSpecifications = productSpecifications;
          }
          if (additionalProductNotes !== selectedRFQ.AdditionalProductNotes) {
            requirementsInput.AdditionalProductNotes = additionalProductNotes;
          }
          if (
            additionalPackagingNotes !== selectedRFQ.AdditionalPackagingNotes
          ) {
            requirementsInput.AdditionalPackagingNotes =
              additionalPackagingNotes;
          }
          if (
            shippingMethodPreference !== selectedRFQ.ShippingMethodPreference
          ) {
            requirementsInput.ShippingMethodPreference =
              shippingMethodPreference;
          }
          if (partialDeliveryAllowed !== selectedRFQ.PartialDeliveryAllowed) {
            requirementsInput.PartialDeliveryAllowed = partialDeliveryAllowed;
          }
          if (
            additionalLogisticsNotes !== selectedRFQ.AdditionalLogisticsNotes
          ) {
            requirementsInput.AdditionalLogisticsNotes =
              additionalLogisticsNotes;
          }
          if (unloadingResponsibility !== selectedRFQ.UnloadingResponsibility) {
            requirementsInput.UnloadingResponsibility = unloadingResponsibility;
          }
          if (transshipmentAllowed !== selectedRFQ.TransshipmentAllowed) {
            requirementsInput.TransshipmentAllowed = transshipmentAllowed;
          }
          if (preferredPaymentMethod !== selectedRFQ.PreferredPaymentMethod) {
            requirementsInput.PreferredPaymentMethod = preferredPaymentMethod;
          }
          if (currency !== selectedRFQ.Currency) {
            requirementsInput.Currency = currency;
          }
          if (paymentTimeline !== selectedRFQ.PaymentTimeline) {
            requirementsInput.PaymentTimeline = paymentTimeline;
          }
          if (
            specialInstructionsSuppliers !==
            selectedRFQ.SpecialInstructionsSuppliers
          ) {
            requirementsInput.SpecialInstructionsSuppliers =
              specialInstructionsSuppliers;
          }
          if (
            qualityInspectionRequired !== selectedRFQ.QualityInspectionRequired
          ) {
            requirementsInput.QualityInspectionRequired =
              qualityInspectionRequired;
          }
          if (internalComments !== selectedRFQ.InternalComments) {
            requirementsInput.InternalComments = internalComments;
          }
          if (
            requiredSupplierCertifications !==
            selectedRFQ.RequiredSupplierCertifications
          ) {
            requirementsInput.RequiredSupplierCertifications =
              requiredSupplierCertifications;
          }

          if (selectedDocsString !== selectedRFQ.RequiredDocuments) {
            requirementsInput.RequiredDocuments = selectedDocsString;
          }
          let cpt = comparisonCriteriaPriority.join(", ");
          if (cpt !== selectedRFQ.ComparisonCriteriaPriority) {
            requirementsInput.ComparisonCriteriaPriority = cpt;
          }

          if (Object.keys(requirementsInput).length > 1) {
            const body = {
              target: "updateRequirements",
              requirementsInput,
            };

            await postQuery(body);
          }

          const paymentConditions = await loadPaymentConditions(
            selectedRFQ.RequirementsID
          );
          const requirementProductInfo = await loadRequirementProductInfo(
            selectedRFQ.RequirementsID
          );

          await Promise.all([
            ...paymentConditions.map(async (pc) => {
              const bodyDelPC = {
                target: "deletePaymentConditions",
                PaymentConditionsID: pc.PaymentConditionsID,
              };
              await postQuery(bodyDelPC);
            }),
            ...requirementProductInfo.map(async (pi) => {
              const bodyDelPI = {
                target: "deleteRequirementProductInfo",
                RequirementProductInfoID: pi.RequirementProductInfoID,
              };
              await postQuery(bodyDelPI);
            }),
          ]);

          const bodyProductInfo = {
            target: "createRequirementProductInfo",
            requirementProductInfoInput: {
              RequirementProductInfoID: uuidv4(),
              RequirementsID: selectedRFQ.RequirementsID,
              Category: categoryValue,
              ProductID: requestedProductID,
              ProductTypeID: productType,
              Deleted: 0,
            },
          };
          await postQuery(bodyProductInfo);

          for (const file of paymentConditionFiles) {
            let uploadedFileName = null;
            if (file instanceof File && !file?.PaymentOptions) {
              const fileresult = await uploadVideoToS3(file);
              if (!fileresult?.fileName) continue;
              uploadedFileName = fileresult.fileName;
            } else if (file?.PaymentOptions) {
              uploadedFileName = file.PaymentOptions;
            }

            if (!uploadedFileName) continue;

            const paymentConditionsID = uuidv4();
            const bodyPC = {
              target: "createPaymentConditions",
              paymentConditionsInput: {
                PaymentConditionsID: paymentConditionsID,
                RequirementsID: selectedRFQ.RequirementsID,
                PaymentOptions: uploadedFileName,
                TermsConditionsFilePath: "",
                OthersFilePath: "",
                Deleted: 0,
              },
            };
            await postQuery(bodyPC);
            insertedPaymentConditionsIDs.push(paymentConditionsID);
          }

          for (const file of termsAndConditions) {
            let uploadedFileName = null;
            if (file instanceof File) {
              const fileresult = await uploadVideoToS3(file);
              if (!fileresult?.fileName) continue;
              uploadedFileName = fileresult.fileName;
            } else {
              uploadedFileName = file.name;
            }

            if (!uploadedFileName) continue;
            const paymentConditionsID = uuidv4();
            const bodyTC = {
              target: "createPaymentConditions",
              paymentConditionsInput: {
                PaymentConditionsID: paymentConditionsID,
                RequirementsID: selectedRFQ.RequirementsID,
                PaymentOptions: "",
                TermsConditionsFilePath: uploadedFileName,
                OthersFilePath: "",
                Deleted: 0,
              },
            };
            await postQuery(bodyTC);
            insertedPaymentConditionsIDs.push(paymentConditionsID);
          }

          for (const file of otherFiles) {
            let uploadedFileName = null;
            if (file instanceof File) {
              const fileresult = await uploadVideoToS3(file);
              if (!fileresult?.fileName) continue;
              uploadedFileName = fileresult.fileName;
            } else {
              uploadedFileName = file.name;
            }

            if (!uploadedFileName) continue;
            const paymentConditionsID = uuidv4();
            const bodyOther = {
              target: "createPaymentConditions",
              paymentConditionsInput: {
                PaymentConditionsID: paymentConditionsID,
                RequirementsID: selectedRFQ.RequirementsID,
                PaymentOptions: "",
                TermsConditionsFilePath: "",
                OthersFilePath: uploadedFileName,
                Deleted: 0,
              },
            };
            await postQuery(bodyOther);
            insertedPaymentConditionsIDs.push(paymentConditionsID);
          }

          const bodyRTH = {
            target: "createRequirementTxnHistory",
            requirementTxnHistoryInput: {
              RequirementTxnHistoryID: uuidv4(),
              RequirementsID: selectedRFQ.RequirementsID,
              ActionedByEmail: activeUser,
              Status: recordStatus,
              Deleted: 0,
            },
          };
          await postQuery(bodyRTH);

          setModal({
            show: true,
            type: "success",
            title: "Success!",
            message: "RFQ updated successfully.",
            autoClose: false,
            nextAction: () => {
              navigate("/global-partner/rfqoffers");
              setIsFormVisible(false);
              searchRFQs(searchValues);
            },
          });
        } else {
          const body = {
            target: "createRequirements",
            requirementsInput: {
              RequirementsID: uuidv4(),
              RequirementNumber: reqNumber,
              GPEmailID: gpEmail,
              BuyerEmailID: " ",
              CreatedByEmailID: activeUser,
              ProductID: requestedProductID,
              Quantity: requestedQuantityValue,
              Price: priceOfferedValue,
              DeliveryDate: deliveryPeriodTillValue,
              RequirementDate: dayjs(curreDate).format("YYYY-MM-DD"),
              MarketPlacement: "No",
              ValidUntil: validUntilValue,
              Incoterm: incotermValue,
              DeliveryLocation: locationsValue,
              DeliveryPeriodFrom: deliveryPeriodFromValue,
              DeliveryPeriodTill: deliveryPeriodTillValue,
              OriginCountry: originCountryValue,
              ProductPackaging: packageingValue,
              RequestedQuantity: requestedQuantityValue,
              PriceOffered: priceOfferedValue,
              Status: recordStatus,
              CategoryType: "rfq",
              Deleted: 0,
              Title: title,
              CreateDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
              SubmitedDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
              HsCode: hsCode,
              Variety: variety,
              ProductSpecifications: productSpecifications,
              AdditionalProductNotes: additionalProductNotes,
              AdditionalPackagingNotes: additionalPackagingNotes,
              ShippingMethodPreference: shippingMethodPreference,
              PartialDeliveryAllowed: partialDeliveryAllowed,
              AdditionalLogisticsNotes: additionalLogisticsNotes,
              UnloadingResponsibility: unloadingResponsibility,
              TransshipmentAllowed: transshipmentAllowed,
              PreferredPaymentMethod: preferredPaymentMethod,
              Currency: currency,
              PaymentTimeline: paymentTimeline,
              SpecialInstructionsSuppliers: specialInstructionsSuppliers,
              QualityInspectionRequired: qualityInspectionRequired,
              InternalComments: internalComments,
              RequiredSupplierCertifications: requiredSupplierCertifications,
              ComparisonCriteriaPriority: comparisonCriteriaPriority.join(", "),
              RequiredDocuments: selectedDocsString,
            },
          };

          const result = await postQuery(body);
          if (!result || !result.items)
            throw new Error("Failed to create RFQ.");
          insertedRequirementsID = result.items.RequirementsID;

          const bodyProductInfo = {
            target: "createRequirementProductInfo",
            requirementProductInfoInput: {
              RequirementProductInfoID: uuidv4(),
              RequirementsID: insertedRequirementsID,
              Category: categoryValue,
              ProductID: requestedProductID,
              ProductTypeID: productType,
              Deleted: 0,
            },
          };
          await postQuery(bodyProductInfo);

          for (const file of paymentConditionFiles) {
            if (!file || !file.name) continue;
            const fileresult = await uploadVideoToS3(file);
            if (!fileresult?.fileName) continue;

            const paymentConditionsID = uuidv4();
            const bodyPC = {
              target: "createPaymentConditions",
              paymentConditionsInput: {
                PaymentConditionsID: paymentConditionsID,
                RequirementsID: insertedRequirementsID,
                PaymentOptions: fileresult.fileName,
                TermsConditionsFilePath: "",
                OthersFilePath: "",
                Deleted: 0,
              },
            };
            await postQuery(bodyPC);
            insertedPaymentConditionsIDs.push(paymentConditionsID);
          }

          for (const file of termsAndConditions) {
            if (!file || !file.name) continue;
            const fileresult = await uploadVideoToS3(file);
            if (!fileresult?.fileName) continue;

            const paymentConditionsID = uuidv4();
            const bodyTC = {
              target: "createPaymentConditions",
              paymentConditionsInput: {
                PaymentConditionsID: paymentConditionsID,
                RequirementsID: insertedRequirementsID,
                PaymentOptions: "",
                TermsConditionsFilePath: fileresult.fileName,
                OthersFilePath: "",
                Deleted: 0,
              },
            };
            await postQuery(bodyTC);
            insertedPaymentConditionsIDs.push(paymentConditionsID);
          }

          for (const file of otherFiles) {
            if (!file || !file.name) continue;
            const fileresult = await uploadVideoToS3(file);
            if (!fileresult?.fileName) continue;

            const paymentConditionsID = uuidv4();
            const bodyOther = {
              target: "createPaymentConditions",
              paymentConditionsInput: {
                PaymentConditionsID: paymentConditionsID,
                RequirementsID: insertedRequirementsID,
                PaymentOptions: "",
                TermsConditionsFilePath: "",
                OthersFilePath: fileresult.fileName,
                Deleted: 0,
              },
            };
            await postQuery(bodyOther);
            insertedPaymentConditionsIDs.push(paymentConditionsID);
          }

          const bodyRTH = {
            target: "createRequirementTxnHistory",
            requirementTxnHistoryInput: {
              RequirementTxnHistoryID: uuidv4(),
              RequirementsID: insertedRequirementsID,
              ActionedByEmail: activeUser,
              Status: recordStatus,
              Deleted: 0,
            },
          };
          await postQuery(bodyRTH);

          setModal({
            show: true,
            type: "success",
            title: "Success!",
            message: "RFQ created successfully.",
            autoClose: false,
            nextAction: () => {
              navigate("/global-partner/rfqoffers");
              setIsFormVisible(false);
              searchRFQs(searchValues);
            },
          });
        }
      } catch (error) {
        console.error("Submission error:", error);
        try {
          await Promise.all(
            insertedPaymentConditionsIDs.map(async (paymentConditionsID) => {
              const bodyDelPC = {
                target: "deletePaymentConditions",
                PaymentConditionsID: paymentConditionsID,
              };
              await postQuery(bodyDelPC);
            })
          );
          if (insertedRequirementsID) {
            const bodyDelR = {
              target: "deleteRequirements",
              RequirementsID: insertedRequirementsID,
            };
            await postQuery(bodyDelR);
          }
        } catch (rollbackError) {
          console.error("Rollback error:", rollbackError);
          setModal({
            show: true,
            type: "error",
            title: "Rollback Error!",
            message:
              "Failed to clean up data after error. Please contact support.",
            autoClose: false,
          });
          setLoading(false);
          setSubmitted(false);
          return;
        }
        setModal({
          show: true,
          type: "error",
          title: "Error!",
          message: error.message || "Failed to submit RFQ.",
          autoClose: false,
        });
      } finally {
        setLoading(false);
        setSubmitted(false);
      }
    }
  };
  // Modal handlers for file uploads
  const handleBackToTermsUploadOptions = useCallback(() => {
    setTermsDocumentValut(false);
    setTempTermsFiles([]);
  }, []);
  const handleAddDocTermsFile = useCallback(() => {
    setTermsDocumentValut(true);
    setTempTermsFiles([]); // Reset temp files
  }, []);
  const handleBackToUploadOptions = () => {
    setOtherFilesDocumentValut(false);
    setTempOtherFiles([]);
  };
  const handleAddDocOtherFile = useCallback(() => {
    setOtherFilesDocumentValut(true);
    setTempOtherFiles([]); // Reset tempOtherFiles when switching to document vault
  }, []);

  const handleBackToPaymentUploadOptions = useCallback(() => {
    setPaymentDocumentValut(false);
    setTempPaymentConditionFiles([]);
  }, []);
  const handleAddDocPaymentFile = useCallback(() => {
    setPaymentDocumentValut(true);
    setTempPaymentConditionFiles([]); // Reset temp files
  }, []);
  //----------

  const handleOpenTermsModal = useCallback(() => {
    if (!isViewMode) {
      setTempTermsFiles([...termsAndConditions]);
      setOpenTermsModal(true);
    }
  }, [termsAndConditions, isViewMode]);

  const handleCloseTermsModal = useCallback(() => {
    setOpenTermsModal(false);
  }, []);

  const handleAddTempTermsFile = useCallback(() => {
    setTempTermsFiles((prev) => [...prev, null]);
  }, []);

  const handleRemoveTempTermsFile = useCallback(
    (index) => {
      if (tempTermsFiles.length > 0) {
        setTempTermsFiles((prev) => prev.filter((_, i) => i !== index));
      }
    },
    [tempTermsFiles]
  );

  const handleTempTermsFileChange = useCallback(
    (index, event) => {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== "application/pdf") {
          setModal({
            show: true,
            type: "error",
            title: "Invalid File",
            message: "Please upload a PDF file.",
            autoClose: false,
          });
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          setModal({
            show: true,
            type: "error",
            title: "File Too Large",
            message: "File size must not exceed 2MB.",
            autoClose: false,
          });
          return;
        }
        const updatedFiles = [...tempTermsFiles];
        updatedFiles[index] = file;
        setTempTermsFiles(updatedFiles);
      }
    },
    [tempTermsFiles]
  );

  const handleConfirmTerms = useCallback(() => {
    const validFiles = tempTermsFiles.filter((file) => file !== null);
    setTermsAndConditions((prevFiles) => {
      const existingFileNames = new Set(prevFiles.map((file) => file.name));
      const newFiles = validFiles.filter(
        (file) => !existingFileNames.has(file.name)
      );
      return [...prevFiles, ...newFiles];
    });
    setOpenTermsModal(false);
  }, [tempTermsFiles]);

  const handleDeleteTermsFile = useCallback(
    (index) => {
      if (!isViewMode) {
        setTermsAndConditions((prevFiles) =>
          prevFiles.filter((_, i) => i !== index)
        );
      }
    },
    [isViewMode]
  );

  const handleOpenFilesModal = useCallback(() => {
    if (!isViewMode) {
      setTempOtherFiles([...otherFiles]);
      setOpenFilesModal(true);
    }
  }, [otherFiles, isViewMode]);

  const handleCloseFilesModal = useCallback(() => {
    setOpenFilesModal(false);
  }, []);

  const handleAddTempOtherFile = useCallback(() => {
    setTempOtherFiles((prev) => [...prev, null]);
  }, []);

  const handleRemoveTempOtherFile = useCallback(
    (index) => {
      if (tempOtherFiles.length > 0) {
        setTempOtherFiles((prev) => prev.filter((_, i) => i !== index));
      }
    },
    [tempOtherFiles]
  );

  const handleTempOtherFileChange = useCallback(
    (index, event) => {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== "application/pdf") {
          setModal({
            show: true,
            type: "error",
            title: "Invalid File",
            message: "Please upload a PDF file.",
            autoClose: false,
          });
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          setModal({
            show: true,
            type: "error",
            title: "File Too Large",
            message: "File size must not exceed 2MB.",
            autoClose: false,
          });
          return;
        }
        const updatedFiles = [...tempOtherFiles];
        updatedFiles[index] = file;
        setTempOtherFiles(updatedFiles);
      }
    },
    [tempOtherFiles]
  );

  const handleConfirmOtherFiles = useCallback(() => {
    const validFiles = tempOtherFiles.filter((file) => file !== null);
    setOtherFiles((prevFiles) => {
      const existingFileNames = new Set(prevFiles.map((file) => file.name));
      const newFiles = validFiles.filter(
        (file) => !existingFileNames.has(file.name)
      );
      return [...prevFiles, ...newFiles];
    });
    setOpenFilesModal(false);
  }, [tempOtherFiles]);

  const handleDeleteOtherFile = useCallback(
    (index) => {
      if (!isViewMode) {
        setOtherFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
      }
    },
    [isViewMode]
  );

  const handleOpenPaymentConditionModal = useCallback(() => {
    if (!isViewMode) {
      setTempPaymentConditionFiles([...paymentConditionFiles]);
      setOpenPaymentConditionModal(true);
    }
  }, [paymentConditionFiles, isViewMode]);

  const handleClosePaymentConditionModal = useCallback(() => {
    setOpenPaymentConditionModal(false);
  }, []);

  const handleAddTempPaymentConditionFile = useCallback(() => {
    setTempPaymentConditionFiles((prev) => [...prev, null]);
  }, []);

  const handleRemoveTempPaymentConditionFile = useCallback(
    (index) => {
      if (tempPaymentConditionFiles.length > 0) {
        setTempPaymentConditionFiles((prev) =>
          prev.filter((_, i) => i !== index)
        );
      }
    },
    [tempPaymentConditionFiles]
  );

  const handleTempPaymentConditionFileChange = useCallback(
    (index, event) => {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== "application/pdf") {
          setModal({
            show: true,
            type: "error",
            title: "Invalid File",
            message: "Please upload a PDF file.",
            autoClose: false,
          });
          return;
        }
        if (file.size > 2 * 1024 * 1024) {
          setModal({
            show: true,
            type: "error",
            title: "File Too Large",
            message: "File size must not exceed 2MB.",
            autoClose: false,
          });
          return;
        }
        const updatedFiles = [...tempPaymentConditionFiles];
        updatedFiles[index] = file;
        setTempPaymentConditionFiles(updatedFiles);
      }
    },
    [tempPaymentConditionFiles]
  );

  const handleConfirmPaymentCondition = useCallback(() => {
    const validFiles = tempPaymentConditionFiles.filter(
      (file) => file !== null
    );
    setPaymentConditionFiles((prevFiles) => {
      const existingFileNames = new Set(prevFiles.map((file) => file.name));
      const newFiles = validFiles.filter(
        (file) => !existingFileNames.has(file.name)
      );
      return [...prevFiles, ...newFiles];
    });
    setOpenPaymentConditionModal(false);
  }, [tempPaymentConditionFiles]);

  const handleDeletePaymentConditionFile = useCallback(
    (index) => {
      if (!isViewMode) {
        setPaymentConditionFiles((prevFiles) =>
          prevFiles.filter((_, i) => i !== index)
        );
      }
    },
    [isViewMode]
  );

  // Auto-load products filtered by category (replaces loadProducts)
  useEffect(() => {
    if (category) {
      const filtered = allProductMaster
        .filter((p) => p.ProductCategoryID === category)
        .sort((a, b) => a.ProductName.localeCompare(b.ProductName));
      setFilteredProductList(filtered);
    } else {
      setFilteredProductList([]);
    }
  }, [category, allProductMaster]);

  // Auto-load grades filtered by category + product (replaces loadProductGrades)
  useEffect(() => {
    if (category && product) {
      const matchingProducts = allProductMaster.filter(
        (p) => p.ProductCategoryID === category && p.ProductName === product
      );
      // Sort by Grade if needed: .sort((a, b) => a.Grade.localeCompare(b.Grade))
      setProductGradeList(matchingProducts);
    } else {
      setProductGradeList([]);
    }
  }, [category, product, allProductMaster]);

  // Auto-load ports filtered by destination (replaces loadFormPorts)
  useEffect(() => {
    if (destination) {
      const matchingPort = allPortList.filter((p) => p.Subtype === destination);
      setFormPortList(matchingPort);
    } else {
      setFormPortList([]);
    }
  }, [destination, allPortList]);

  useEffect(() => {
    loadAllDropdowns();

    if (formMode === "edit" || formMode === "view") {
      if (selectedRFQ) {
        console.log("RequiredDocuments@@", selectedRFQ.RequiredDocuments);

        let existingRequiredDocuments =
          selectedRFQ.RequiredDocuments &&
            selectedRFQ.RequiredDocuments.trim() !== ""
            ? selectedRFQ.RequiredDocuments.trim()
              .split(",")
              .map((doc) => doc.trim())
            : [];
        setSelectedRequiredDocuments(existingRequiredDocuments);
        // Load basic RFQ information
        setTitle(selectedRFQ.Title || "");
        setBuyerEmailID(activeUser || selectedRFQ.GPEmailID);
        setCreateDate(
          selectedRFQ.CreateDate
            ? dayjs(selectedRFQ.CreateDate).format("M/D/YYYY")
            : dayjs().format("M/D/YYYY")
        );
        setSubmitedDate(
          selectedRFQ.SubmitedDate
            ? dayjs(selectedRFQ.SubmitedDate).format("M/D/YYYY")
            : ""
        );

        // Load commodity details
        setHsCode(selectedRFQ.HsCode || "");
        setVariety(selectedRFQ.Variety || "");
        setProductSpecifications(selectedRFQ.ProductSpecifications || "");
        setAdditionalProductNotes(selectedRFQ.AdditionalProductNotes || "");

        // Load quantity and packaging
        setRequestedQuantity(
          selectedRFQ.RequestedQuantity || selectedRFQ.Quantity || ""
        );

        // Handle ProductPackaging as object with item and size
        if (selectedRFQ.ProductPackaging) {
          if (typeof selectedRFQ.ProductPackaging === "object") {
            setProductPackaging(selectedRFQ.ProductPackaging.item || "");
            setPackageSize(selectedRFQ.ProductPackaging.size || "");
          } else if (typeof selectedRFQ.ProductPackaging === "string") {
            try {
              // Try to parse as JSON first
              const parsed = JSON.parse(selectedRFQ.ProductPackaging);
              if (parsed.item !== undefined || parsed.size !== undefined) {
                setProductPackaging(parsed.item || "");
                setPackageSize(parsed.size || "");
              } else {
                throw new Error("Not a valid packaging object");
              }
            } catch (e) {
              // Parse string format like "{item=sack, size=25kg-sack}"
              const packagingStr = selectedRFQ.ProductPackaging;
              if (
                packagingStr.includes("item=") &&
                packagingStr.includes("size=")
              ) {
                const itemMatch = packagingStr.match(/item=([^,}]+)/);
                const sizeMatch = packagingStr.match(/size=([^,}]+)/);

                const item = itemMatch ? itemMatch[1].trim() : "";
                const size = sizeMatch ? sizeMatch[1].trim() : "";

                setProductPackaging(item);
                setPackageSize(size);
              } else {
                // For backward compatibility with plain string format
                setProductPackaging(selectedRFQ.ProductPackaging);
                setPackageSize("");
              }
            }
          }
        } else {
          setProductPackaging("");
          setPackageSize("");
        }

        setAdditionalPackagingNotes(selectedRFQ.AdditionalPackagingNotes || "");

        // Load delivery terms
        setShippingMethodPreference(selectedRFQ.ShippingMethodPreference || "");
        setPartialDeliveryAllowed(selectedRFQ.PartialDeliveryAllowed || 0);
        setAdditionalLogisticsNotes(selectedRFQ.AdditionalLogisticsNotes || "");
        setUnloadingResponsibility(selectedRFQ.UnloadingResponsibility || "");
        setTransshipmentAllowed(selectedRFQ.TransshipmentAllowed || 0);

        // Load pricing and payment
        setPriceOffered(selectedRFQ.PriceOffered || selectedRFQ.Price || "");
        setCurrency(selectedRFQ.Currency || "");
        setPreferredPaymentMethod(selectedRFQ.PreferredPaymentMethod || "");
        setPaymentTimeline(selectedRFQ.PaymentTimeline || "");
        setSpecialInstructionsSuppliers(
          selectedRFQ.SpecialInstructionsSuppliers || ""
        );
        setQualityInspectionRequired(
          selectedRFQ.QualityInspectionRequired || 0
        );
        setRequiredSupplierCertifications(
          selectedRFQ.RequiredSupplierCertifications || 0
        );
        setComparisonCriteriaPriority(
          selectedRFQ.ComparisonCriteriaPriority
            ? selectedRFQ.ComparisonCriteriaPriority.split(", ").filter(
              (item) => item.trim() !== ""
            )
            : []
        );

        // Load others
        setInternalComments(selectedRFQ.InternalComments || "");

        const productData = allProductMaster.find(
          (p) => p.ProductID === selectedRFQ.ProductID
        );
        const categoryId = productData?.ProductCategoryID || "";
        const productName = productData?.ProductName || "";
        const grade = productData?.Grade || "";
        setCategory(categoryId);
        setProduct(productName);
        setGrade(grade);
        // setFormProduct(productData ? [productData] : []);
        loadFormProductInfo(productName, grade);
        setHsCode(productData?.HsCode || "");
        setVariety(productData?.Variety || "");

        // setProductGradeList([]);
        // setFormProduct([]);
        // setCategory(categoryId);
        // setProduct("");
        // setGrade("");

        // if (categoryId) {
        //   loadProducts(categoryId);
        // }

        // if (productName) {
        //   setProduct(productName);
        //   loadProductGrades(productName);
        // } else {
        //   setProduct("");
        //   setProductGradeList([]);
        // }

        // if (productName && grade) {
        //   setGrade(grade);

        //   loadFormProductInfo(productName, grade);
        // } else {
        //   setGrade("");
        //   setFormProduct([]);
        // }

        // Parse DeliveryLocation into destination and deliveryPort
        const deliveryLocation = selectedRFQ.DeliveryLocation || "";
        const [destinationValue, deliveryPortValue] =
          deliveryLocation.split("~");

        setOrigin(selectedRFQ.OriginCountry || "");
        setDestination(destinationValue || "");
        setDeliveryPort(deliveryPortValue || "");
        if (destinationValue) {
          loadFormPorts(destinationValue);
        }
        setIncoterm(selectedRFQ.Incoterm || "");
        setValidUntil(
          selectedRFQ.ValidUntil
            ? dayjs(selectedRFQ.ValidUntil).format("YYYY-MM-DD")
            : ""
        );
        setDeliveryPeriodFrom(
          selectedRFQ.DeliveryPeriodFrom
            ? dayjs(selectedRFQ.DeliveryPeriodFrom).format("YYYY-MM-DD")
            : ""
        );
        setDeliveryPeriodTill(
          selectedRFQ.DeliveryPeriodTill
            ? dayjs(selectedRFQ.DeliveryPeriodTill).format("YYYY-MM-DD")
            : ""
        );

        // Load payment conditions and files
        loadPaymentConditions(selectedRFQ.RequirementsID).then(
          (paymentConditions) => {
            const paymentFiles = paymentConditions
              .filter((pc) => pc.PaymentOptions)
              .map(
                (pc) =>
                  new File([""], pc.PaymentOptions.split("/").pop(), {
                    type: "application/pdf",
                  })
              );
            const termsFiles = paymentConditions
              .filter((pc) => pc.TermsConditionsFilePath)
              .map(
                (pc) =>
                  new File([""], pc.TermsConditionsFilePath.split("/").pop(), {
                    type: "application/pdf",
                  })
              );
            const otherFilesData = paymentConditions
              .filter((pc) => pc.OthersFilePath)
              .map(
                (pc) =>
                  new File([""], pc.OthersFilePath.split("/").pop(), {
                    type: "application/pdf",
                  })
              );

            setPaymentConditionFiles(paymentFiles);
            setTermsAndConditions(termsFiles);
            setOtherFiles(otherFilesData);
          }
        );

        setTabValue(0);
      }
    } else if (formMode === "add") {
      // Set defaults for new RFQ
      setBuyerEmailID(activeUser);
      setCreateDate(dayjs().format("M/D/YYYY"));
      setSubmitedDate("");
    }
  }, [
    formMode,
    selectedRFQ,
    allProductMaster,
    activeUser,
    loadAllDropdowns,
    // loadCountries,
    // loadPaymentTerms,
    // loadIncoterms,
    // loadProductCategories,
    // loadProducts,
    // loadProductGrades,
    loadFormProductInfo,
    // loadFormPorts,
    loadPaymentConditions,
    // loadPackaging,
    // loadBankList,
  ]);

  // Separate useEffect to handle package sizes loading
  useEffect(() => {
    if (packagingMaster.length > 0 && productPackaging) {
      loadPackageSizes(productPackaging);
    }
  }, [packagingMaster, productPackaging, loadPackageSizes]);

  return (
    <Box
      sx={{
        width: "100%",
        marginTop: 2,
        boxShadow: "1px 1px 5px #ccc",
        padding: "15px",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "#de6b14",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 1,
        }}
      >
        <Typography variant="h6">
          {formMode === "add" && "Add RFQ"}
          {formMode === "edit" &&
            `Edit RFQ ${selectedRFQ?.RequirementNumber
              ? `- ${selectedRFQ.RequirementNumber}`
              : ""
            }`}
          {formMode === "view" &&
            `View RFQ ${selectedRFQ?.RequirementNumber
              ? `- ${selectedRFQ.RequirementNumber}`
              : ""
            }`}
        </Typography>
        {formMode === "add" && (
          <FormControlLabel
            control={
              <Checkbox
                checked={addFinanceRFQ}
                onChange={handleAddFinanceRFQChange}
                disabled={isViewMode}
              />
            }
            label="Create Finance RFQ with this Trade RFQ"
            sx={{ ml: 2 }}
          />
        )}
        <Box>
          {btnCancel && (
            <Button
              variant="outlined"
              color="error"
              onClick={() => setIsFormVisible(false)}
              sx={{ marginRight: 1 }}
            >
              Cancel
            </Button>
          )}
          {btnAddFinanceRfq && isViewMode && (
            <Button
              variant="contained"
              onClick={handleOpenFinanceRFQModal}
              sx={{
                marginRight: 1,
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#de6b14" },
              }}
            >
              Add Finance RFQ
            </Button>
          )}
          {btnHistory && isViewMode && openHistory && (
            <Button
              variant="outlined"
              color="error"
              onClick={() => ForHistory(selectedRFQ?.RequirementNumber)}
              sx={{ marginRight: 1 }}
            >
              History
            </Button>
          )}

          {formMode === "view" && selectedRFQ?.Status === "Rejected" && (
            <Button
              variant="contained"
              onClick={() => setFormMode("edit")}
              sx={{ marginRight: 1, backgroundColor: "#1976d2" }}
            >
              Edit
            </Button>
          )}
          {(formMode === "add" || formMode === "edit") && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#de6b14" },
              }}
              onClick={handleSubmit}
              disabled={submitted}
            >
              {submitted
                ? "Submitting..."
                : formMode === "edit"
                  ? "Update"
                  : "Submit"}
            </Button>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%", // ✅ ensures full width
          borderBottom: 1,
          borderColor: "#de6b14",
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="RFQ form tabs"
          variant="fullWidth" 
          sx={{
            width: "100%", 
            "& .MuiTab-root": {
              color: "#000",
              backgroundColor: "transparent",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.95rem",
              minHeight: "48px",
              "&.Mui-selected": {
                color: "#fff",
                backgroundColor: "#de6b14",
              },
            },
            "& .MuiTabs-flexContainer": {
              width: "100%", 
            },
            "& .MuiTabs-indicator": { backgroundColor: "#de6b14" },
          }}
        >
          <Tab label="RFQ Information" id="tab-0" aria-controls="tabpanel-0" />
          <Tab label="Commodity Details" id="tab-1" aria-controls="tabpanel-1" />
          <Tab label="Quantity & Packaging" id="tab-2" aria-controls="tabpanel-2" />
          <Tab label="Delivery Terms" id="tab-3" aria-controls="tabpanel-3" />
          <Tab
            label="Pricing/Payment/Guarantee"
            id="tab-4"
            aria-controls="tabpanel-4"
          />
          <Tab label="Others" id="tab-5" aria-controls="tabpanel-5" />
        </Tabs>
      </Box>


      <TabPanel value={tabValue} index={0}>
        <RFQInformationTab
          title={title}
          setTitle={setTitle}
          createDate={createDate}
          setCreateDate={setCreateDate}
          submitedDate={submitedDate}
          setSubmitedDate={setSubmitedDate}
          validUntil={validUntil}
          setValidUntil={setValidUntil}
          buyerEmailID={buyerEmailID}
          errors={errors}
          isViewMode={isViewMode}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <CommodityDetailsTab
          setLoading={setLoading}
          category={category}
          setCategory={setCategory}
          product={product}
          setProduct={setProduct}
          hsCode={hsCode}
          setHsCode={setHsCode}
          grade={grade}
          setGrade={setGrade}
          variety={variety}
          setVariety={setVariety}
          productSpecifications={productSpecifications}
          setProductSpecifications={setProductSpecifications}
          origin={origin}
          setOrigin={setOrigin}
          additionalProductNotes={additionalProductNotes}
          setAdditionalProductNotes={setAdditionalProductNotes}
          productCategoryMaster={productCategoryMaster}
          setProductCategoryMaster={setProductCategoryMaster}
          filteredProductList={filteredProductList}
          productGradeList={productGradeList}
          countrymaster={countrymaster}
          loadProducts={loadProducts}
          loadProductGrades={loadProductGrades}
          loadFormProductInfo={loadFormProductInfo}
          errors={errors}
          isViewMode={isViewMode}
          allProductMaster={allProductMaster}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <QuantityPackagingTab
          requestedQuantity={requestedQuantity}
          setRequestedQuantity={setRequestedQuantity}
          productPackaging={productPackaging}
          setProductPackaging={setProductPackaging}
          packageSize={packageSize}
          setPackageSize={setPackageSize}
          additionalPackagingNotes={additionalPackagingNotes}
          setAdditionalPackagingNotes={setAdditionalPackagingNotes}
          packagingMaster={packagingMaster}
          filteredPackageSizes={filteredPackageSizes}
          loadPackageSizes={loadPackageSizes}
          errors={errors}
          isViewMode={isViewMode}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <DeliveryTermsTab
          // setLoading={setLoading}
          destination={destination}
          setDestination={setDestination}
          deliveryPort={deliveryPort}
          setDeliveryPort={setDeliveryPort}
          incoterm={incoterm}
          setIncoterm={setIncoterm}
          incotermsMaster={incotermsMaster}
          shippingMethodMaster={shippingMethodMaster}
          // setIncotermsMaster={setIncotermsMaster}
          deliveryPeriodFrom={deliveryPeriodFrom}
          setDeliveryPeriodFrom={setDeliveryPeriodFrom}
          deliveryPeriodTill={deliveryPeriodTill}
          setDeliveryPeriodTill={setDeliveryPeriodTill}
          shippingMethodPreference={shippingMethodPreference}
          setShippingMethodPreference={setShippingMethodPreference}
          partialDeliveryAllowed={partialDeliveryAllowed}
          setPartialDeliveryAllowed={setPartialDeliveryAllowed}
          additionalLogisticsNotes={additionalLogisticsNotes}
          setAdditionalLogisticsNotes={setAdditionalLogisticsNotes}
          unloadingResponsibility={unloadingResponsibility}
          setUnloadingResponsibility={setUnloadingResponsibility}
          transshipmentAllowed={transshipmentAllowed}
          setTransshipmentAllowed={setTransshipmentAllowed}
          countrymaster={countrymaster}
          formPortList={formPortList}
          loadFormPorts={loadFormPorts}
          errors={errors}
          isViewMode={isViewMode}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={4}>
        <PricingPaymentTab
          priceOffered={priceOffered}
          setPriceOffered={setPriceOffered}
          currency={currency}
          setCurrency={setCurrency}
          paymentTermMaster={paymentTermMaster}
          preferredPaymentMethod={preferredPaymentMethod}
          setPreferredPaymentMethod={setPreferredPaymentMethod}
          paymentTimeline={paymentTimeline}
          setPaymentTimeline={setPaymentTimeline}
          specialInstructionsSuppliers={specialInstructionsSuppliers}
          setSpecialInstructionsSuppliers={setSpecialInstructionsSuppliers}
          qualityInspectionRequired={qualityInspectionRequired}
          setQualityInspectionRequired={setQualityInspectionRequired}
          requiredSupplierCertifications={requiredSupplierCertifications}
          setRequiredSupplierCertifications={setRequiredSupplierCertifications}
          comparisonCriteriaPriority={comparisonCriteriaPriority}
          setComparisonCriteriaPriority={setComparisonCriteriaPriority}
          errors={errors}
          isViewMode={isViewMode}
        />
      </TabPanel>

      <TabPanel value={tabValue} index={5}>
        <OthersTab
          internalComments={internalComments}
          setInternalComments={setInternalComments}
          termsAndConditions={termsAndConditions}
          handleOpenTermsModal={handleOpenTermsModal}
          handleDeleteTermsFile={handleDeleteTermsFile}
          otherFiles={otherFiles}
          handleOpenFilesModal={handleOpenFilesModal}
          handleDeleteOtherFile={handleDeleteOtherFile}
          requiredDocumentsMaster={requiredDocumentsMaster}
          setRequiredDocumentsMaster={setRequiredDocumentsMaster}
          selectedRequiredDocuments={selectedRequiredDocuments}
          setSelectedRequiredDocuments={setSelectedRequiredDocuments}
          errors={errors}
          isViewMode={isViewMode}
          fileUrl={fileUrl}
          setDocumentCategoryMaster={setDocumentCategoryMaster}
          documentCategoryMaster={documentCategoryMaster}
          setLoading={setLoading}
          activeUser={activeUser}
          setDocumentVaultUserFiles={setDocumentVaultUserFiles}
          documentVaultUserFiles={documentVaultUserFiles}
        />
      </TabPanel>

      {/* Modal components for file uploads */}
      <Modal open={openTermsModal} onClose={handleCloseTermsModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">Upload Terms & Conditions</Typography>
            <IconButton onClick={handleCloseTermsModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {termsDocumentValut ? (
            <>
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToTermsUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>
              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    setSelectedTermsVaultFile(newValue);
                    setTempTermsFiles([]); // Clear previous selections
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ff9800",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fb8c00",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff3e0",
                        },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>
              {selectedTermsVaultFile && (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  <Autocomplete
                    options={documentVaultUserFiles.filter(
                      (doc) => doc.Category === selectedTermsVaultFile.Value
                    )}
                    getOptionLabel={(option) => option.DocumentName || ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const file = {
                          name: newValue.DocumentName,
                          DocumentFile: newValue.DocumentFile,
                        };
                        setTempTermsFiles((prev) => [...prev, file]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Type to search documents..."
                        variant="outlined"
                        sx={{
                          height: "40px !important",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            borderRadius: "4px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff9800",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fb8c00",
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "#fff3e0",
                          },
                        }}
                      >
                        <Typography variant="body2">
                          {option.DocumentName}
                        </Typography>
                      </Box>
                    )}
                    noOptionsText="No documents found"
                    sx={{ backgroundColor: "white" }}
                  />
                </FormControl>
              )}
              <Box>
                {tempTermsFiles.length > 0 ? (
                  tempTermsFiles.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px",
                        borderRadius: "8px",
                        bgcolor: "#f5f5f5",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body2">
                        {file?.name || "Pending selection"}
                      </Typography>
                      <IconButton
                        onClick={() => {
                          const updated = [...tempTermsFiles];
                          updated.splice(index, 1);
                          setTempTermsFiles(updated);
                        }}
                      >
                        <CloseIcon sx={{ color: "#555" }} />
                      </IconButton>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No files selected
                  </Typography>
                )}
              </Box>
            </>
          ) : tempTermsFiles.length > 0 ? (
            <>
              {tempTermsFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center", mb: 2 }}
                >
                  <TextField
                    type="file"
                    onChange={(e) => handleTempTermsFileChange(index, e)}
                    sx={{ flexGrow: 1, mr: 1 }}
                    inputProps={{
                      accept: "application/pdf",
                      "aria-label": `Terms File ${index + 1}`,
                    }}
                  />
                  {file && (
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      {file.name}
                    </Typography>
                  )}
                  <IconButton
                    onClick={() => handleRemoveTempTermsFile(index)}
                    disabled={tempTermsFiles.length === 0}
                  >
                    <RemoveIcon
                      sx={{
                        backgroundColor: "#fb8c00",
                        color: "#fff",
                        borderRadius: "24px",
                        width: "35px",
                        height: "35px",
                      }}
                    />
                  </IconButton>
                  <IconButton onClick={handleAddTempTermsFile}>
                    <AddIcon
                      sx={{
                        backgroundColor: "#fb8c00",
                        color: "#fff",
                        borderRadius: "24px",
                        width: "35px",
                        height: "35px",
                        "&:hover": { backgroundColor: "#fb8c00" },
                      }}
                    />
                  </IconButton>
                </Box>
              ))}
            </>
          ) : (
            <div className="doc-des">
              <Button
                variant="outlined"
                onClick={handleAddDocTermsFile}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload File from Document Vault
              </Button>
              <br />
              <Button
                variant="outlined"
                onClick={handleAddTempTermsFile}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload file from Local Drive
              </Button>
            </div>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmTerms}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>

      <Modal open={openFilesModal} onClose={handleCloseFilesModal}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">Upload Other Files</Typography>
            <IconButton onClick={handleCloseFilesModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {/* Conditional rendering based on OtherFilesDocumentValut */}
          {OtherFilesDocumentValut ? (
            <>
              {/* Back Button */}
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>
              {/* First Autocomplete for documentCategoryMaster */}
              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    setSelectedVaultFile(newValue);
                    setTempOtherFiles([]); // Clear previous selections
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ff9800",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fb8c00",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff3e0",
                        },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>
              {/* Second Autocomplete for documentVaultUserFiles when a category is selected */}
              {selectedVaultFile && (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  <Autocomplete
                    options={documentVaultUserFiles.filter(
                      (doc) => doc.Category === selectedVaultFile.Value
                    )}
                    getOptionLabel={(option) => option.DocumentName || ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const file = {
                          name: newValue.DocumentName,
                          DocumentFile: newValue.DocumentFile,
                        };
                        setTempOtherFiles((prev) => [...prev, file]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Type to search documents..."
                        variant="outlined"
                        sx={{
                          height: "40px !important",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            borderRadius: "4px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff9800",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fb8c00",
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "#fff3e0",
                          },
                        }}
                      >
                        <Typography variant="body2">
                          {option.DocumentName}
                        </Typography>
                      </Box>
                    )}
                    noOptionsText="No documents found"
                    sx={{ backgroundColor: "white" }}
                  />
                </FormControl>
              )}
              {/* Selected Files List */}
              <Box>
                {tempOtherFiles.length > 0 ? (
                  tempOtherFiles.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px",
                        borderRadius: "8px",
                        bgcolor: "#f5f5f5",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body2">{file.name}</Typography>
                      <IconButton
                        onClick={() => {
                          const updated = [...tempOtherFiles];
                          updated.splice(index, 1);
                          setTempOtherFiles(updated);
                        }}
                      >
                        <CloseIcon sx={{ color: "#555" }} />
                      </IconButton>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No files selected
                  </Typography>
                )}
              </Box>
            </>
          ) : tempOtherFiles.length > 0 ? (
            <>
              {tempOtherFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center", mb: 2 }}
                >
                  <TextField
                    type="file"
                    onChange={(e) => handleTempOtherFileChange(index, e)}
                    sx={{ flexGrow: 1, mr: 1 }}
                    inputProps={{
                      accept: "application/pdf",
                      "aria-label": `Other File ${index + 1}`,
                    }}
                  />
                  {file && (
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      {file.name}
                    </Typography>
                  )}
                  <IconButton
                    onClick={() => handleRemoveTempOtherFile(index)}
                    disabled={tempOtherFiles.length === 0}
                  >
                    <RemoveIcon
                      sx={{
                        backgroundColor: "#fb8c00",
                        color: "#fff",
                        borderRadius: "24px",
                        width: "35px",
                        height: "35px",
                      }}
                    />
                  </IconButton>
                  <IconButton onClick={handleAddTempOtherFile}>
                    <AddIcon
                      sx={{
                        backgroundColor: "#fb8c00",
                        color: "#fff",
                        borderRadius: "24px",
                        width: "35px",
                        height: "35px",
                        "&:hover": { backgroundColor: "#fb8c00" },
                      }}
                    />
                  </IconButton>
                </Box>
              ))}
            </>
          ) : (
            <div className="doc-des">
              <Button
                variant="outlined"
                onClick={handleAddDocOtherFile}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload File from Document Vault
              </Button>
              <br />
              <Button
                variant="outlined"
                onClick={handleAddTempOtherFile}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload file from Local Drive
              </Button>
            </div>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmOtherFiles}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>

      <Modal
        open={openPaymentConditionModal}
        onClose={handleClosePaymentConditionModal}
      >
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="h6">Upload Payment Conditions</Typography>
            <IconButton onClick={handleClosePaymentConditionModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          {paymentDocumentValut ? (
            <>
              <Box sx={{ mb: 2, display: "flex", justifyContent: "end" }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBackToPaymentUploadOptions}
                  sx={{
                    border: "1px solid #FF5722",
                    color: "#FF5722",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              </Box>
              <FormControl sx={{ width: "100%", mb: 3 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                >
                  Search Document Category
                </Typography>
                <Autocomplete
                  options={documentCategoryMaster}
                  getOptionLabel={(option) => option.Value || ""}
                  onChange={(event, newValue) => {
                    setSelectedPaymentVaultFile(newValue);
                    setTempPaymentConditionFiles([]); // Clear previous selections
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Type to search categories..."
                      variant="outlined"
                      sx={{
                        height: "40px !important",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& fieldset": {
                            borderColor: "#ccc",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ff9800",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fb8c00",
                          },
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#fff3e0",
                        },
                      }}
                    >
                      <Typography variant="body2">{option.Value}</Typography>
                    </Box>
                  )}
                  noOptionsText="No categories found"
                  sx={{ backgroundColor: "white" }}
                />
              </FormControl>
              {selectedPaymentVaultFile && (
                <FormControl sx={{ width: "100%", mb: 3 }}>
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, color: "#666", fontWeight: 500 }}
                  >
                    Select Document
                  </Typography>
                  <Autocomplete
                    options={documentVaultUserFiles.filter(
                      (doc) => doc.Category === selectedPaymentVaultFile.Value
                    )}
                    getOptionLabel={(option) => option.DocumentName || ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const file = {
                          name: newValue.DocumentName,
                          DocumentFile: newValue.DocumentFile,
                        };
                        setTempPaymentConditionFiles((prev) => [...prev, file]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Type to search documents..."
                        variant="outlined"
                        sx={{
                          height: "40px !important",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                            borderRadius: "4px",
                            "& fieldset": {
                              borderColor: "#ccc",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ff9800",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fb8c00",
                            },
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "#fff3e0",
                          },
                        }}
                      >
                        <Typography variant="body2">
                          {option.DocumentName}
                        </Typography>
                      </Box>
                    )}
                    noOptionsText="No documents found"
                    sx={{ backgroundColor: "white" }}
                  />
                </FormControl>
              )}
              <Box>
                {tempPaymentConditionFiles.length > 0 ? (
                  tempPaymentConditionFiles.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px",
                        borderRadius: "8px",
                        bgcolor: "#f5f5f5",
                        mb: 1,
                      }}
                    >
                      <Typography variant="body2">
                        {file?.name || "Pending selection"}
                      </Typography>
                      <IconButton
                        onClick={() => {
                          const updated = [...tempPaymentConditionFiles];
                          updated.splice(index, 1);
                          setTempPaymentConditionFiles(updated);
                        }}
                      >
                        <CloseIcon sx={{ color: "#555" }} />
                      </IconButton>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" sx={{ color: "#666" }}>
                    No files selected
                  </Typography>
                )}
              </Box>
            </>
          ) : tempPaymentConditionFiles.length > 0 ? (
            <>
              {tempPaymentConditionFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center", mb: 2 }}
                >
                  <TextField
                    type="file"
                    onChange={(e) =>
                      handleTempPaymentConditionFileChange(index, e)
                    }
                    sx={{ flexGrow: 1, mr: 1 }}
                    inputProps={{
                      accept: "application/pdf",
                      "aria-label": `Payment Condition File ${index + 1}`,
                    }}
                  />
                  {file && (
                    <Typography variant="body2" sx={{ mr: 1 }}>
                      {file.name}
                    </Typography>
                  )}
                  <IconButton
                    onClick={() => handleRemoveTempPaymentConditionFile(index)}
                    disabled={tempPaymentConditionFiles.length === 0}
                  >
                    <RemoveIcon
                      sx={{
                        backgroundColor: "#fb8c00",
                        color: "#fff",
                        borderRadius: "24px",
                        width: "35px",
                        height: "35px",
                      }}
                    />
                  </IconButton>
                  <IconButton onClick={handleAddTempPaymentConditionFile}>
                    <AddIcon
                      sx={{
                        backgroundColor: "#fb8c00",
                        color: "#fff",
                        borderRadius: "24px",
                        width: "35px",
                        height: "35px",
                        "&:hover": { backgroundColor: "#fb8c00" },
                      }}
                    />
                  </IconButton>
                </Box>
              ))}
            </>
          ) : (
            <div className="doc-des">
              <Button
                variant="outlined"
                onClick={handleAddDocPaymentFile}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload File from Document Vault
              </Button>
              <br />
              <Button
                variant="outlined"
                onClick={handleAddTempPaymentConditionFile}
                sx={{
                  mb: 1,
                  width: "300px",
                  border: "1px solid #FF5722",
                  color: "#fff",
                  textTransform: "capitalize",
                  backgroundColor: "#fb8c00",
                }}
              >
                Upload file from Local Drive
              </Button>
            </div>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleConfirmPaymentCondition}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>

      {/* Add mode -finance rfq moadal */}
      <Modal open={openFinancePopup} onClose={handleFinancePopupCancel}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6">Select Finance Details</Typography>
            <IconButton onClick={handleFinancePopupCancel}>
              <CloseIcon />
            </IconButton>
          </Box>
          <FormControl
            fullWidth
            sx={{ mb: 3 }}
            error={!!errors.financeInstrument}
          >
            <Typography variant="body2">Select Instrument *</Typography>
            <Select
              value={financeInstrument || ""}
              onChange={handleFinanceInstrumentChange}
              size="small"
              placeholder="Select Instrument"
              sx={{
                backgroundColor: "white",
                borderRadius: "4px",
                "& .MuiSelect-select": { padding: "8px 14px" },
              }}
              inputProps={{ "aria-label": "Select Instrument" }}
            >
              <MenuItem value="" disabled>
                Select Instrument
              </MenuItem>
              {[
                "Letter of Credit (LC) - Sight / Usance / Back-to-Back",
                "Deferred Payment Terms with LC",
                "Bank Guarantee (BG) - Payment / Performance",
                "Standby Letter of Credit (SBLC)",
                "Buyer's Credit / Trade Loan",
                "Documentary Collection (D/P or D/A)",
                "Open Account with Credit Insurance",
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            {errors.financeInstrument && (
              <FormHelperText>{errors.financeInstrument}</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth sx={{ mb: 3 }}>
            <Typography variant="body2">Select Banks *</Typography>
            <Select
              multiple
              value={selectedBanks}
              onChange={handleBankSelectionChange}
              input={<OutlinedInput />}
              renderValue={(selected) =>
                selected
                  .map(
                    (id) =>
                      bankList.find((bank) => bank.BankID === id)?.BankName
                  )
                  .join(", ")
              }
              sx={{ backgroundColor: "white" }}
            >
              {bankList.map((bank) => (
                <MenuItem key={bank.BankID} value={bank.BankID}>
                  <Checkbox checked={selectedBanks.includes(bank.BankID)} />
                  <ListItemText primary={bank.BankName} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="outlined"
              onClick={handleFinancePopupCancel}
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleFinancePopupConfirm}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Modal>
      {/* View mode -finance rfq moadal */}
      <GenerateFinanceRFQModal
        open={openFinanceRFQModal}
        onClose={handleCloseFinanceRFQModal}
        buyerInfo={buyerInfo}
        rfqData={selectedRFQ}
        activeUser={activeUser}
        bankList={bankList}
        allProductMaster={allProductMaster}
      />
    </Box>
  );
};

export default RFQForm;
